import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  FormGroup,
  Container,
  Row,
  Col,
  Table,
  Input,
  Card,
  CardBody,
  CardHeader,
  Media,
} from "reactstrap";
import * as queries from "../../../graphql/queries";
import "rc-pagination/assets/index.css";
import "../../../assets/scss/index.less";
import moment from "moment";
import DatePicker from "react-datepicker";
import { H5, Btn } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Line } from "react-chartjs-2";
import { SiteContext } from "../../../App";
import { SiteDetailsContext } from "../../../App";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import * as mergedQueries from "../../../graphql/mergedQueries";
import SPCompany from "../../../Data/SPCompanyData/index";
import SiteData from "../../../Data/Sites/index";
import CategoryData from "../../../Data/Category/index";
import AssetTemplate from "../../../Data/AssetTemplate/index";
import SiteDBData from "../../../Data/DistributionBoard/index";
import { generateClient } from "aws-amplify/api";
import axios from "axios";
import Chart from "react-apexcharts";
import { areaSpaline } from "../../Charts/apexCharts/apexData";
import CommenHeader from "../../Charts/Commen";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
var base64 = require("base-64");

const AssetOwnerDashboard = () => {
  const [series, setSeries] = useState([]);
  const [taskSeries, setTaskSeries] = useState([]);
  const [taskCategories, setTaskCategories] = useState([]);
  const navigate = useNavigate();
  const LoginUserGroup = localStorage.getItem("groups");
  if (LoginUserGroup === "site_user") {
    navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
  }
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [isLoading, setIsLoading] = useState(false);
  const [fulldata, setFulldata] = useState([]);
  const [fullSites, setFullsites] = useState([]);
  const [loadingassets, setLoadingassets] = useState(false);
  const [loadingtasks, setLoadingtask] = useState(false);
  useEffect(() => {
    dashboardCount(LoginUserDetails.id);

    const from = moment().subtract(6, "days").startOf("day").toISOString();
    const to = moment().endOf("day").toISOString();
    plotTasks(LoginUserDetails.id);
    if (LoginUserGroup === "spao") {
      fetchSPCompanySPAO(LoginUserDetails);
    } else if (LoginUserGroup === "site_owner") {
      fetchSpcompany(LoginUserDetails.id);
    }
    setIsLoading(true);
    fetchCategory();
    fetchAssetTemplate();
    fetchSiteDetailsAO(LoginUserDetails.id, "Today");
    return () => client.cancel();
  }, []);

  const taskOptions = {
    chart: {
      type: "area",
      stacked: false,
      toolbar: { show: false },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: "category",
      categories: taskCategories,
      labels: {
        rotate: -45,
        formatter: (val) => moment(val).format("MMM DD"),
      },
    },
    yaxis: {
      title: {
        text: "Number of Tasks",
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
  };

  // async function plotTasks(from, to) {
  //   const statusName = ["Hold", "Pending", "Completed", "Assigned"];

  //   try {
  //     // Create last 7 days
  //     setLoadingtask(true);
  //     const last7Days = Array.from({ length: 7 }).map((_, i) =>
  //       moment()
  //         .subtract(6 - i, "days")
  //         .format("YYYY-MM-DD")
  //     );
  //     setTaskCategories(last7Days);

  //     let allItems = [];
  //     let nextToken = null;

  //     // Fetch all tasks using pagination
  //     do {
  //       const { data } = await client.graphql({
  //         query: queries.listTasks,
  //         variables: {
  //           limit: 1000,
  //           filter: {
  //             assignedBy: { eq: LoginUserDetails.id },
  //             createdAt: { between: [from, to] },
  //           },
  //           nextToken,
  //         },
  //       });

  //       const result = data.listTasks;
  //       allItems = allItems.concat(result.items || []);
  //       nextToken = result.nextToken;
  //     } while (nextToken);

  //     // Initialize all status counts to 0 per day
  //     const statusMap = {};
  //     statusName.forEach((status) => {
  //       statusMap[status] = {};
  //       last7Days.forEach((day) => {
  //         statusMap[status][day] = 0;
  //       });
  //     });

  //     // Fill actual task counts
  //     allItems.forEach((task) => {
  //       const day = moment(task.createdAt).format("YYYY-MM-DD");
  //       const status = task.taskStatus;

  //       if (statusName.includes(status)) {
  //         statusMap[status][day] += 1;
  //       }
  //     });

  //     // Format for ApexChart
  //     const formattedSeries = statusName.map((status) => ({
  //       name: status,
  //       data: last7Days.map((day) => ({
  //         x: day,
  //         y: statusMap[status][day] || 0,
  //       })),
  //     }));
  //     setLoadingtask(false);
  //     setTaskSeries(formattedSeries);
  //   } catch (error) {
  //     console.error("Error fetching task data:", error);
  //   }
  //   finally {
  //     setLoadingtask(false);
  //   }
  // }

  async function plotTasks(loginUserDetailsId) {
    const statusNames = ["Hold", "Pending", "Completed", "Assigned"];
    setLoadingtask(true);

    try {
      const last7Days = Array.from({ length: 7 }).map((_, i) =>
        moment
          .utc()
          .subtract(6 - i, "days")
          .format("YYYY-MM-DD")
      );
      setTaskCategories(last7Days);

      const { data } = await client.graphql({
        query: queries.getUserTasks7DayStats,
        variables: { loginUserDetailsId },
      });

      console.log("7 days", data);
      const stats = data.getUserTasks7DayStats || [];

      const formattedSeries = statusNames.map((status) => {
        const statusData = stats.find((s) => s.status === status);
        const seriesData = last7Days.map((day) => {
          const countObj = statusData?.data?.find((d) => d.date === day);
          return {
            x: day,
            y: countObj ? countObj.count : 0,
          };
        });
        return {
          name: status,
          data: seriesData,
        };
      });

      setTaskSeries(formattedSeries);
    } catch (error) {
      console.error(" Error fetching task data:", error);
    } finally {
      setLoadingtask(false);
    }
  }

  async function dashboardCount(user) {
    try {
      const getdata = await client.graphql({
        query: queries.listDashboardCounts,
        authMode: "API_KEY",
        variables: {
          limit: 10000,
          filter: {
            userId: {
              eq: user,
            },
          },
        },
      });
      console.log("data ", getdata);
      if (getdata.data.listDashboardCounts.items.length > 0) {
        console.log(getdata.data.listDashboardCounts.items);
        setFulldata(getdata.data.listDashboardCounts.items);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchSPCompanySPAO(user) {
    try {
      const getLinkAOAPCompanyDetails = await client.graphql({
        query: queries.listLinkAOAPCompanies,
        authMode: "API_KEY",
        variables: {
          limit: 10000,
          filter: {
            spaoId: {
              eq: user.id,
            },
          },
        },
      });
      console.log("company " + user.id, getLinkAOAPCompanyDetails);
      if (
        getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items.length > 0
      ) {
        SPCompany.setSPCompany(
          getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items
        );
        localStorage.setItem(
          "spCompany",
          base64.encode(
            JSON.stringify(
              getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items
            )
          )
        );
      }
    } catch (error) {
      console.log(error);
      //setIsLoading(false);
    }
  }

  async function fetchSpcompany(asetOwnerId) {
    try {
      const getLinkAOAPCompanyDetails = await client.graphql({
        query: queries.listLinkAOAPCompanies,
        authMode: "API_KEY",
        variables: {
          limit: 10000,
          filter: {
            spaoId: {
              eq: asetOwnerId,
            },
          },
        },
      });
      console.log("company " + asetOwnerId, getLinkAOAPCompanyDetails);
      if (
        getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items.length > 0
      ) {
        SPCompany.setSPCompany(
          getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items
        );
        localStorage.setItem(
          "spCompany",
          base64.encode(
            JSON.stringify(
              getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items
            )
          )
        );
      }
      return () => client.cancel();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function fetchSiteDetailsAO(assetOwnerId, onDateRangeSelected) {
    try {
      setIsLoading(true);

      // const dbSummaryResults = await client.graphql({
      //   query: queries.getAssetCountsSummary,
      //   variables: {
      //     assetownerID: assetOwnerId,
      //   },
      //   authMode: "API_KEY",
      // });
      // const dbSummary = dbSummaryResults.data.getAssetCountsSummary;
      // console.log("DB Summary:", dbSummary);

      console.log("Site Count:", assetOwnerId);
      const variables = {
        status: "",
        onDateRange: "",
        assetOwnerID: assetOwnerId,
      };

      const results = await client.graphql({
        query: queries.getSiteSummary,
        variables,
        authMode: "API_KEY",
      });

      const result = results.data.getSiteSummary;
      console.log("Site count response:", result);
      SiteData.setSiteData(result.sites);
      if (result.sites.length > 0) {
        const mergeSites = result.sites.flat(1);
        localStorage.setItem("site", base64.encode(JSON.stringify(mergeSites)));
        setFullsites(mergeSites);
        const from = moment().subtract(7, "days").startOf("day").toISOString();
        const to = moment().endOf("day").toISOString();

        const now = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(now.getDate() - 7);

        const startDate = sevenDaysAgo.toISOString();
        const endDate = now.toISOString();

        plotAssetsGraph(mergeSites);
        SiteData.setSiteData(mergeSites);

        let assetCount = [];

        for (let i = 0; i < mergeSites.length; i++) {
          const item = mergeSites[i];

          try {
            const result = await client.graphql({
              query: queries.assetCountsBySitedetailsID,
              variables: {
                sitedetailsID: item.id,
                limit: 10000,
              },
            });

            const counts = result?.data?.assetCountsBySitedetailsID;

            if (counts?.items?.length > 0) {
              assetCount.push(...counts.items);
            }
          } catch (error) {
            console.error(`Error fetching site ${item.id}`, error);
          }
        }

        // Sum up the assetCount
        const totalAssetCount = assetCount.reduce(
          (acc, current) => acc + current.assetCount,
          0
        );

        console.log(onDateRangeSelected);
        console.log(totalAssetCount);

        if (onDateRangeSelected === "All Time") {
          setAssetsCount(totalAssetCount);
        }

        localStorage.setItem(
          "categoryAssetCount",
          base64.encode(JSON.stringify(assetCount))
        );
        //setSiteDetails(mergeSites);
        fetchSpcompany(mergeSites);
        fetchlistDistributionBox(mergeSites);
        //fetchAssets(mergeSites, "Today");

        //----SU/SP set
        if (mergeSites.length > 0) {
          const siteIds = mergeSites
            .filter((site) => site.status === "Active")
            .map((site) => site.id);

          // ---chunk arrays ---
          const chunkArray = (arr, size) => {
            const chunks = [];
            for (let i = 0; i < arr.length; i += size) {
              chunks.push(arr.slice(i, i + size));
            }
            return chunks;
          };

          const chunkSize = 20;
          const siteIdChunks = chunkArray(siteIds, chunkSize);

          let allSummaries = { site_user: [], electrician: [] };

          for (const chunk of siteIdChunks) {
            const results = await client.graphql({
              query: queries.getSiteUsersAndElectricians,
              variables: {
                siteIds: chunk,
                onDateRange: "",
              },
              authMode: "API_KEY",
            });

            const summaries = results.data.getSiteUsersAndElectricians;

            if (summaries) {
              allSummaries.site_user.push(...(summaries.site_user || []));
              allSummaries.electrician.push(...(summaries.electrician || []));
            }
          }

          console.log("summaries su/sp", allSummaries);

          const siteUsers = allSummaries.site_user || [];
          const electricians = allSummaries.electrician || [];

          // --- Deduplicate users ---
          const uniqueSiteUsers = Array.from(
            new Map(
              siteUsers.map((user) => [user.id || user.userID, user])
            ).values()
          );

          const uniqueElectricians = Array.from(
            new Map(
              electricians.map((user) => [user.id || user.userID, user])
            ).values()
          );

          console.log("Site Users:", uniqueSiteUsers.length);
          const suInvitedBy = uniqueSiteUsers.filter(
            (item) => item.invitedBy === LoginUserDetails.id
          );
          console.log("sudataa", suInvitedBy);
          console.log("Electricians:", uniqueElectricians.length);

          localStorage.setItem(
            "site_userlist",
            base64.encode(JSON.stringify(suInvitedBy))
          );
          localStorage.setItem(
            "electricianlist",
            base64.encode(JSON.stringify(uniqueElectricians))
          );

          return allSummaries;
        } else {
          return [];
        }
        //---END----
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching site count:", error);
      setIsLoading(false);
    }
    // try {
    //   setIsLoading(true);
    //   let nextToken = "";
    //   let sites = [];
    //   const result = await client.graphql({
    //     query: queries.siteDetailsByAssetownerID,
    //     variables: {
    //       assetownerID: assetOwnerId,
    //       limit: 200000,
    //     },
    //     authMode: "API_KEY",
    //   });
    //   console.log(result);
    //   if (result.data.siteDetailsByAssetownerID.items.length > 0) {
    //     let assetDatas = result.data.siteDetailsByAssetownerID.items;
    //     nextToken = result.data.siteDetailsByAssetownerID.nextToken;
    //     if (result.data.siteDetailsByAssetownerID.items.length > 0) {
    //       sites.push(assetDatas);
    //     }
    //     while (nextToken !== null) {
    //       const results = await client.graphql({
    //         query: queries.siteDetailsByAssetownerID,
    //         variables: {
    //           assetownerID: assetOwnerId,
    //           limit: 200000,
    //           nextToken: nextToken,
    //         },
    //         authMode: "API_KEY",
    //       });
    //       console.log(results);
    //       if (results.data.siteDetailsByAssetownerID.items.length > 0) {
    //         nextToken = results.data.siteDetailsByAssetownerID.nextToken;
    //         if (results.data.siteDetailsByAssetownerID.items.length > 0) {
    //           sites.push(results.data.siteDetailsByAssetownerID.items);
    //         }
    //       }
    //     }
    //     console.log(sites);
    //   }
    //   return () => client.cancel();
    // } catch (error) {
    //   console.log(error);
    //   setIsLoading(false);
    // }
  }

  // async function plotAssetsGraph(sitesdata, from, to) {
  //   try {
  //     setLoadingassets(true);
  //     const dailyCountsMap = {};

  //     await Promise.all(
  //       sitesdata.map(async (siteId) => {
  //         let allItems = [];
  //         let nextToken = null;

  //         // Loop through pages using nextToken
  //         do {
  //           const { data } = await client.graphql({
  //             query: queries.assetsBySitedetailsID,
  //             variables: {
  //               sitedetailsID: siteId.id,
  //               limit: 1000, // max limit per request (realistic), adjust if needed
  //               nextToken,
  //               filter: {
  //                 createdAt: {
  //                   between: [from, to],
  //                 },
  //               },
  //             },
  //           });

  //           const result = data.assetsBySitedetailsID;
  //           allItems = allItems.concat(result.items || []);
  //           nextToken = result.nextToken;
  //         } while (nextToken);

  //         console.log("Querying from:", from, "to:", to);
  //         console.log("items-", siteId.siteName, allItems.length);

  //         // Group by day
  //         allItems.forEach((item) => {
  //           const day = moment(item.createdAt).format("YYYY-MM-DD");
  //           dailyCountsMap[day] = (dailyCountsMap[day] || 0) + 1;
  //         });
  //       })
  //     );

  //     // Return exactly last 7 days (including today)
  //     const last7Days = Array.from({ length: 8 }).map((_, i) => {
  //       const day = moment()
  //         .subtract(6 - i, "days")
  //         .format("YYYY-MM-DD");
  //       return {
  //         x: day,
  //         y: dailyCountsMap[day] || 0,
  //       };
  //     });
  //     setLoadingassets(false);
  //     setSeries([
  //       {
  //         name: "Total Assets",
  //         data: last7Days,
  //       },
  //     ]);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  //   finally {
  //     setLoadingassets(false);
  //   }
  // }

  async function plotAssetsGraph(sitedata) {
    try {
      setLoadingassets(true);

      const activesites = sitedata.filter((item) => item.status === "Active");
      const siteIds = activesites.map((asset) => asset.id);
      if (!siteIds || siteIds.length === 0) return;

      const { data } = await client.graphql({
        query: queries.getAssetsBySiteIdsPast7Days,
        variables: { siteIds },
      });

      const result = data.getAssetsBySiteIdsPast7Days || [];

      const last7Days = Array.from({ length: 7 }).map((_, i) => {
        const day = moment()
          .subtract(6 - i, "days")
          .format("YYYY-MM-DD");
        const dayData = result.find((r) => r.date === day);
        return {
          x: day,
          y: dayData ? dayData.totalAssets : 0,
        };
      });

      setSeries([
        {
          name: "Total Assets",
          data: last7Days,
        },
      ]);
    } catch (error) {
      console.error("Error fetching assets:", error);
    } finally {
      setLoadingassets(false);
    }
  }

  async function fetchCategory() {
    try {
      setIsLoading(true);
      let nextToken = "";
      let categories = [];
      const dataDetails = await client.graphql({
        query: queries.listCategories,
        authMode: "API_KEY",
        variables: {
          limit: 200000,
        },
      });
      if (dataDetails.data.listCategories.items.length > 0) {
        let assetDatas = dataDetails.data.listCategories.items;
        nextToken = dataDetails.data.listCategories.nextToken;
        if (dataDetails.data.listCategories.items.length > 0) {
          categories.push(assetDatas);
        }
        while (nextToken !== null) {
          const dataDetailss = await client.graphql({
            query: queries.listCategories,
            variables: {
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dataDetailss.data.listCategories.items.length > 0) {
            nextToken = dataDetailss.data.listCategories.nextToken;
            if (dataDetailss.data.listCategories.items.length > 0) {
              categories.push(dataDetailss.data.listCategories.items);
            }
          }
        }
        console.log(categories);
        if (categories.length > 0) {
          const mergeCategories = categories.flat(1);
          CategoryData.setCategoryData(mergeCategories);
          localStorage.setItem(
            "category",
            base64.encode(JSON.stringify(mergeCategories))
          );
          setIsLoading(false);
        }
      }
      return () => client.cancel();
    } catch (error) {
      console.log(error);
      CategoryData.setCategoryData([]);
      setIsLoading(false);
    }
  }
  //---spuser
  async function fetchSpuser(sites) {
    //--
    try {
      let userIds = [];
      let nextToken1 = "";
      console.log(sites);
      const filterSites = sites.filter(
        (item) => item.id === selectedSiteGlobal
      );
      const filtersitesss = selectedSiteGlobal ? filterSites : sites;
      if (filtersitesss.length > 0) {
        for (let site of filtersitesss) {
          const getSiteIds = await client.graphql({
            query: queries.linkUsersAndSitesBySitedetailsID,
            authMode: "API_KEY",
            variables: {
              sitedetailsID: site.id,
              filter: {
                status: {
                  eq: "Active",
                },
              },
            },
          });
          console.log(getSiteIds);
          if (
            getSiteIds.data.linkUsersAndSitesBySitedetailsID.items.length > 0
          ) {
            nextToken1 =
              getSiteIds.data.linkUsersAndSitesBySitedetailsID.nextToken;
            userIds.push(
              getSiteIds.data.linkUsersAndSitesBySitedetailsID.items
            );
            while (nextToken1 !== null) {
              const getSiteIds1 = await client.graphql({
                query: queries.linkUsersAndSitesBySitedetailsID,
                authMode: "API_KEY",
                variables: {
                  sitedetailsID: site.id,
                  filter: {
                    status: {
                      eq: "Active",
                    },
                  },
                  nextToken: nextToken1,
                },
              });
              console.log(getSiteIds1);
              if (
                getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items.length >
                0
              ) {
                nextToken1 =
                  getSiteIds1.data.linkUsersAndSitesBySitedetailsID.nextToken;
                userIds.push(
                  getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items
                );
              }
            }
            console.log(userIds);
            if (userIds.length > 0) {
              const mergeUserIds = userIds.flat(1);
              const response1 = await client.graphql({
                query: queries.listSPUserDetails,
                authMode: "API_KEY",
                variables: {
                  // filter: {
                  //   userGroup: {
                  //     eq: "electrician",
                  //   },
                  // },
                  limit: 200000,
                },
              });
              console.log(response1);
              if (response1.data.listSPUserDetails.items.length > 0) {
                const spDetails2 =
                  response1.data.listSPUserDetails.items.filter((item) => {
                    const _matchSites = mergeUserIds?.find(
                      (user) => user.userdetailsID === item?.id
                    );
                    if (_matchSites) {
                      return item;
                    }
                  });
                console.log(spDetails2);
                const sortedItems = spDetails2.sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                });
                console.log(sortedItems);
                localStorage.setItem(
                  "spuser",
                  base64.encode(JSON.stringify(sortedItems))
                );
              }
            } else {
            }
          }
        }
      } else {
      }
      return () => client.cancel();
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchAssetTemplate() {
    try {
      setIsLoading(true);
      let nextToken = "";
      let assetTemplates = [];
      const dataDetails = await client.graphql({
        query: queries.listAssetTemplates,
        authMode: "API_KEY",
        variables: {
          limit: 200000,
        },
      });
      if (dataDetails.data.listAssetTemplates.items.length > 0) {
        let assetDatas = dataDetails.data.listAssetTemplates.items;
        nextToken = dataDetails.data.listAssetTemplates.nextToken;
        if (dataDetails.data.listAssetTemplates.items.length > 0) {
          assetTemplates.push(assetDatas);
        }
        while (nextToken !== null) {
          const dataDetailss = await client.graphql({
            query: queries.listAssetTemplates,
            variables: {
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dataDetailss.data.listAssetTemplates.items.length > 0) {
            nextToken = dataDetailss.data.listAssetTemplates.nextToken;
            if (dataDetailss.data.listAssetTemplates.items.length > 0) {
              assetTemplates.push(dataDetailss.data.listAssetTemplates.items);
            }
          }
        }
        console.log(assetTemplates);
        if (assetTemplates.length > 0) {
          const mergeAssetTemplates = assetTemplates.flat(1);
          AssetTemplate.setAssetTemplate(mergeAssetTemplates);
          localStorage.setItem(
            "assetTemp",
            base64.encode(JSON.stringify(mergeAssetTemplates))
          );
          setIsLoading(false);
        }
      }
      return () => client.cancel();
    } catch (error) {
      console.log(error);
      AssetTemplate.setAssetTemplate([]);
      setIsLoading(false);
    }
  }

  async function fetchlistDistributionBox(siteData) {
    try {
      const siteIDs = siteData
        .filter((site) => site.status === "Active")
        .map((site) => site.id);

      console.log("DB Summary :");
      const dbSummaryResults = await client.graphql({
        query: queries.getDBSummary,
        variables: {
          sitedetailsID: siteIDs,
        },
        authMode: "API_KEY",
      });
      const dbSummary = dbSummaryResults.data.getDBSummary;
      console.log("DB Summary data:", dbSummary);
      SiteDBData.setSiteDBData(dbSummary);
      console.log("SiteDB", dbSummary);
      localStorage.setItem("siteDB", base64.encode(JSON.stringify(dbSummary)));
      // let nextToken1 = "";
      // let logbookBySites = [];
      // const activesites = siteData.filter((item) => item.status === "Active");
      // let count = 0;
      // for (let item of activesites) {
      //   count = count + 1;
      //   const result = await client.graphql({
      //     query: queries.distributionBoxesBySitedetailsID,
      //     variables: {
      //       sitedetailsID: item.id,
      //       filter: {
      //         status: {
      //           eq: "Active",
      //         },
      //       },
      //       limit: 200000,
      //     },
      //     authMode: "API_KEY",
      //   });
      //   if (result.data.distributionBoxesBySitedetailsID.items.length > 0) {
      //     let assetDatas = result.data.distributionBoxesBySitedetailsID.items;
      //     nextToken1 = result.data.distributionBoxesBySitedetailsID.nextToken;
      //     if (result.data.distributionBoxesBySitedetailsID.items.length > 0) {
      //       logbookBySites.push(assetDatas);
      //     }
      //     while (nextToken1 !== null) {
      //       const results = await client.graphql({
      //         query: queries.distributionBoxesBySitedetailsID,
      //         variables: {
      //           sitedetailsID: item.id,
      //           limit: 200000,
      //           filter: {
      //             status: {
      //               eq: "Active",
      //             },
      //           },
      //           nextToken: nextToken1,
      //         },
      //         authMode: "API_KEY",
      //       });
      //       if (
      //         results.data.distributionBoxesBySitedetailsID.items.length > 0
      //       ) {
      //         nextToken1 =
      //           results.data.distributionBoxesBySitedetailsID.nextToken;
      //         logbookBySites.push(
      //           results.data.distributionBoxesBySitedetailsID.items
      //         );
      //       } else {
      //         nextToken1 = null;
      //       }
      //     }
      //     if (count === activesites.length) {
      //       if (logbookBySites.length > 0) {
      //         SiteDBData.setSiteDBData(logbookBySites.flat(1));
      //         console.log("SiteDB", logbookBySites.flat(1));
      //         localStorage.setItem(
      //           "siteDB",
      //           base64.encode(JSON.stringify(logbookBySites.flat(1)))
      //         );
      //       } else {
      //       }
      //     }
      //   }
      // }
    } catch (error) {
      console.log(error);
    }
  }

  const [graphLabelsLogBooks, setgraphLabelsLogBooks] = useState([]);
  const [graphDataLogBooks, setgraphDataLogBooks] = useState([]);
  const [graphLabelsRepairs, setgraphLabelsRepairs] = useState([]);
  const [graphDataRepairs, setgraphDataRepairs] = useState([]);
  const [graphLabelsTests, setgraphLabelsTests] = useState([]);
  const [graphDataTests, setgraphDataTests] = useState([]);
  const [graphLabelsSites, setgraphLabelsSites] = useState([]);
  const [graphDataSites, setgraphDataSites] = useState([]);
  const [graphLabelsAssets, setgraphLabelsAssets] = useState([]);
  const [graphDataAssets, setgraphDataAssets] = useState([]);
  const [graphLabelsSP, setgraphLabelsSP] = useState([]);
  const [graphDataSP, setgraphDataSP] = useState([]);
  const [graphLabelsSiteUsers, setgraphLabelsSiteUsers] = useState([]);
  const [graphDataSiteUsers, setgraphDataSiteUsers] = useState([]);
  const [graphLabelsPI, setgraphLabelsPI] = useState([]);
  const [graphDataPI, setgraphDataPI] = useState([]);
  const [graphLabelsWarranty, setgraphLabelsWarranty] = useState([]);
  const [graphDataWarranty, setgraphDataWarranty] = useState([]);
  const { selectedSiteGlobal, handleSiteChange } = useContext(SiteContext);
  //console.log(selectedSiteGlobal);
  const { siteDetailsGlobal, handleSiteDetailsChange } =
    useContext(SiteDetailsContext);
  const chartWarranty = {
    labels: graphLabelsWarranty.reverse(),
    datasets: [
      {
        label: "Warranty",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataWarranty,
      },
    ],
  };
  const chartRepairs = {
    labels: graphLabelsRepairs.reverse(),
    datasets: [
      {
        label: "Repairs",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataRepairs,
      },
    ],
  };
  const chartTests = {
    labels: graphLabelsTests.reverse(),
    datasets: [
      {
        label: "Tests",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataTests,
      },
    ],
  };
  const chartSP = {
    labels: graphLabelsSP.reverse(),
    datasets: [
      {
        label: "Service Providers",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataSP,
      },
    ],
  };
  const chartSiteUsers = {
    labels: graphLabelsSiteUsers.reverse(),
    datasets: [
      {
        label: "SiteUsers",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataSiteUsers,
      },
    ],
  };
  const chartSites = {
    labels: graphLabelsSites.reverse(),
    datasets: [
      {
        label: "Sites",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataSites,
      },
    ],
  };
  const chartAssets = {
    labels: graphLabelsAssets.reverse(),
    datasets: [
      {
        label: "Assets",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataAssets,
      },
    ],
  };
  const chartLogBooks = {
    labels: graphLabelsLogBooks.reverse(),
    datasets: [
      {
        label: "LogBooks",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataLogBooks,
      },
    ],
  };
  const chartPendingInvitations = {
    labels: graphLabelsPI.reverse(),
    datasets: [
      {
        label: "Pending Invitations",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#2d85c3",
        data: graphDataPI,
      },
    ],
  };
  //-------single Calendar-----
  const [dateRange, setDateRange] = useState([null, null]);
  function SingleCalendar() {
    const [startDate, endDate] = dateRange;
    const handleDateRangeChange = (dates) => {
      // if (dates && dates.length === 2) {
      //   console.log("dates", dates);
      //   setDateRange(dates);
      //   fetchAssets(siteDetails, "Custom");
      //   fetchSitesDetails("Custom");
      //   fetchServiceProviderDetails("Custom");
      //   fetchSiteUserDetails("Custom");
      // }
      if (dates && dates.length === 2 && dates[0] && dates[1]) {
        console.log("dates", dates);

        const dateRangeString = `${dates[0].toString()}_to_${dates[1].toString()}`;
        console.log("dateRangeString:", dateRangeString);
        fetchTestingDetails(fullSites, dateRangeString);
        fetchRepairDetails(fullSites, dateRangeString);
        setDateRange(dates);
        fetchAssets(siteDetails, "Custom");
        //fetchServiceProviderDetails("Custom");
        fetchServiceProviderDetails(dateRangeString);
        //fetchSiteUserDetails("Custom");
        fetchSitesDetails(dateRangeString);
      } else {
        setDateRange(dates);
      }
    };
    return (
      <Fragment>
        <Row className="d-flex justify-content-end">
          <Col xl="6">
            <div className="daterange-card">
              <div className="mb-3">
                <FormGroup>
                  <DatePicker
                    className="form-control digits"
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleDateRangeChange}
                    isClearable={true}
                    placeholderText="Enter Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </FormGroup>
              </div>
            </div>
          </Col>
        </Row>
      </Fragment>
    );
  }
  //-------------Daterange Start-----------------------------------------------------
  const [selectedOption, setSelectedOption] = useState("All Time");
  const [dateRange1, setDateRange1] = useState([new Date(), new Date()]);
  const handleDateRangeSelected = (range) => {
    setDateRange1(range);
    console.log(range);
  };
  const onDateRangeSelected = (range) => {
    //setSelectedOption("");
    console.log(range);
    handleDateRangeSelected(range);
  };
  function DateRangePicker({ onDateRangeSelected }) {
    //const [selectedOption, setSelectedOption] =  useState('');

    const handleOptionChange = (event) => {
      setSelectedOption(event.target.value);
      console.log(selectedOption);

      switch (event.target.value) {
        case "Today":
          onDateRangeSelected(getTodayRange());

          break;
        case "This Week":
          onDateRangeSelected(getWeekRange());

          break;
        case "This Month":
          onDateRangeSelected(getMonthRange());

          break;
        case "This Year":
          onDateRangeSelected(getThisYearRange());

          break;
        case "All Time":
          onDateRangeSelected(getAllTimeRange());

          break;

        default:
          break;
      }
    };
    //---------------------------------------------------------------------------
    const getTodayRange = () => {
      const today = new Date();
      const from = moment(today).startOf("day").toISOString();
      const to = moment(today).endOf("day").toISOString();
      //plotTasks(from, to);
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      //plotAssetsGraph(sd, from, to);
      fetchTestingDetails(fullSites, "Today");
      fetchRepairDetails(fullSites, "Today");
      fetchSitesDetails("Today");
      fetchAssets(siteDetails, "Today");
      fetchServiceProviderDetails("Today");
      //fetchSiteUserDetails("Today");
    };

    //---------------------------------------------------------------------------
    const getAllTimeRange = () => {
      const start = new Date(0);
      const end = new Date();
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      const from = moment().subtract(7, "days").startOf("day").toISOString();
      const to = moment().endOf("day").toISOString();
      // plotTasks(from, to);
      // plotAssetsGraph(sd, from, to);
      //fetchTestingDetails(fullSites, "Today");
      // fetchAssets(siteDetails, "All Time");
      // fetchSitesDetails("All Time");
      // fetchServiceProviderDetails("All Time");
      // fetchSiteUserDetails("All Time");
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [start, end];
    };
    //---------------------------------------------------------------------------
    const getWeekRange = () => {
      const currentDate = new Date();
      const currentDayOfWeek = currentDate.getDay();
      const startOfWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - currentDayOfWeek
      );
      const endOfWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + (6 - currentDayOfWeek)
      );

      const today = new Date();
      console.log(today);
      console.log(moment(startOfWeek).format("DD/MM/YYYY"));

      console.log(endOfWeek);

      const from = moment(startOfWeek).startOf("day").toISOString();
      const to = moment(endOfWeek).endOf("day").toISOString();
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      // plotTasks(from, to);
      // plotAssetsGraph(sd, from, to);
      fetchTestingDetails(fullSites, "This Week");
      fetchAssets(siteDetails, "This Week");
      fetchSitesDetails("This Week");
      fetchRepairDetails(fullSites, "This Week");
      //fetchServiceProviderDetails("This Week");
      fetchServiceProviderDetails("This Week");
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [startOfWeek, endOfWeek];
    };
    //-----------------------------------------------------------------------
    const getMonthRange = () => {
      console.log("month range");
      const currentDate = new Date();
      const startOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const endOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );
      const from = moment(startOfMonth).startOf("day").toISOString();
      const to = moment(endOfMonth).endOf("day").toISOString();
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      // plotTasks(from, to);
      // plotAssetsGraph(sd, from, to);
      fetchTestingDetails(fullSites, "This Month");
      fetchRepairDetails(fullSites, "This Month");
      fetchAssets(siteDetails, "This Month");
      fetchSitesDetails("This Month");
      //fetchServiceProviderDetails("This Month");
      fetchServiceProviderDetails("This Month");
      //fetchSiteUserDetails("This Month");
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [startOfMonth, endOfMonth];
    };
    //---------------------------------------------------------------------------
    const getThisYearRange = () => {
      const currentDate = new Date();
      const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
      const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
      const from = moment(startOfThisYear).startOf("day").toISOString();
      const to = moment(endOfThisYear).endOf("day").toISOString();
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      // plotTasks(from, to);
      // plotAssetsGraph(sd, from, to);
      // fetchAssets(siteDetails, "This Year");
      // fetchSitesDetails("This Year");
      // fetchServiceProviderDetails("This Year");
      // fetchSiteUserDetails("This Year");
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [startOfThisYear, endOfThisYear];
    };
    //---------------------------------------------------------------------------------
    return (
      <div className="daterange-card">
        <Row>
          <Col xs="6">
            <FormGroup>
              <Input
                type="select"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option
                  value="All Time"
                  selected={selectedOption === "All Time"}
                >
                  All Time
                </option>
                <option value="Today" selected={selectedOption === "Today"}>
                  Today
                </option>
                <option
                  value="This Week"
                  selected={selectedOption === "This Week"}
                >
                  This Week
                </option>
                <option
                  value="This Month"
                  selected={selectedOption === "This Month"}
                >
                  This Month
                </option>
                {/* <option
                  value="This Year"
                  selected={selectedOption === "This Year"}
                >
                  This Year
                </option> */}
                <option value="Custom" selected={selectedOption === "Custom"}>
                  Custom
                </option>
              </Input>
            </FormGroup>
          </Col>
          <Col xs="6">
            <FormGroup>
              {selectedOption === "Custom" && (
                <SingleCalendar onDateRangeSelected={onDateRangeSelected} />
              )}
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
  //--------------Daterange End----------------------------------------------------
  //-------------- Asset Owner Start -------------------------------------------
  const [assetOwnerDetailsList, setAssetOwnerDetailsList] = useState([]);
  //--------------Assets ---------------
  const [assetsList, setAssetsList] = useState([]);
  const [siteDetails, setSiteDetails] = useState([]);
  const [assetsCount, setAssetsCount] = useState("");
  const [listofServiceProviders, setlistofServiceProviders] = useState();
  const [testingDetailsList, setTestingDetailsList] = useState(0);
  const [repairDetailsList, setRepairDetailsList] = useState(0);
  const [warantyDetailsList, setWarrantyDetailsList] = useState([]);
  const [logBookDetailsList, setLogBookDetailsList] = useState([]);
  const [listofSiteUsers, setListofSiteUsers] = useState([]);

  useEffect(() => {
    // fetchSitesDetails(siteDetails, "Today");
    // fetchAssets(siteDetails, "Today");
    // fetchServiceProviderDetails("Today");
    // fetchSiteUserDetails("Today");
    return () => client.cancel();
  }, [selectedSiteGlobal]);

  async function fetchAssetOwnerDetailsData(onDateRangeSelected) {
    //---Week--
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const startOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDayOfWeek
    );
    const endOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDayOfWeek)
    );
    // ---Month
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    // ---year
    const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
    const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
    //---custom -----
    const [startDate, endDate] = dateRange;
    let countsArray = [];
    let monthArray = [];
    setIsLoading(true);
    let nextToken = "";
    let assets = [];
    await client
      .graphql({
        query: queries.listLinkUsersAndSites,
        authMode: "API_KEY",
        variables: {
          limit: 20000,
          filter: {
            status: {
              eq: "Active",
            },
          },
        },
      })
      .then(async (result) => {
        let assetDatas = result.data.listLinkUsersAndSites.items;
        nextToken = result.data.listLinkUsersAndSites.nextToken;
        console.log(
          "first token count",
          result.data.listLinkUsersAndSites.items.length
        );
        console.log("nextToken 1", nextToken);
        if (result.data.listLinkUsersAndSites.items.length > 0) {
          assets.push(assetDatas);
        }
        while (nextToken !== null) {
          await client
            .graphql({
              query: queries.listLinkUsersAndSites,
              authMode: "API_KEY",
              variables: {
                limit: 20000,
                nextToken: nextToken,
                filter: {
                  status: {
                    eq: "Active",
                  },
                },
              },
              authMode: "API_KEY",
            })
            .then((results) => {
              nextToken = results.data.listLinkUsersAndSites.nextToken;
              console.log("nextToken", nextToken);
              console.log(results.data.listLinkUsersAndSites.items.length);
              if (results.data.listLinkUsersAndSites.items.length > 0) {
                assets.push(results.data.listLinkUsersAndSites.items);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
        console.log(assets);
        if (assets.length > 0) {
          const mergeAssets = assets.flat(1);
          console.log(mergeAssets);
          const linkedUsers = mergeAssets;
          const spDetailss = linkedUsers.filter((item) => {
            const _matchSites = siteDetailsGlobal?.find(
              (site) => site.id === item?.sitedetailsID
            );
            if (_matchSites) {
              return item;
            }
          });
          console.log(spDetailss);
          const filterSites = spDetailss.filter(
            (item) => item.sitedetailsID === selectedSiteGlobal
          );
          const filtersitesss = selectedSiteGlobal ? filterSites : spDetailss;
          console.log(siteDetailsGlobal);
          console.log(filtersitesss);
          //--
          let nextToken1 = "";
          let assets1 = [];
          await client
            .graphql({
              query: queries.listSPUserDetails,
              authMode: "API_KEY",
              variables: {
                limit: 200000,
              },
            })
            .then(async (result) => {
              let assetDatas = result.data.listSPUserDetails.items;
              nextToken1 = result.data.listSPUserDetails.nextToken;
              console.log(
                "first token count",
                result.data.listSPUserDetails.items.length
              );
              console.log("nextToken 1", nextToken1);
              if (result.data.listSPUserDetails.items.length > 0) {
                assets1.push(assetDatas);
              }
              while (nextToken1 !== null) {
                await client
                  .graphql({
                    query: queries.listSPUserDetails,
                    authMode: "API_KEY",
                    variables: {
                      limit: 200000,
                      nextToken: nextToken1,
                    },
                    authMode: "API_KEY",
                  })
                  .then((results) => {
                    nextToken1 = results.data.listSPUserDetails.nextToken;
                    console.log("nextToken", nextToken1);
                    console.log(results.data.listSPUserDetails.items.length);
                    if (results.data.listSPUserDetails.items.length > 0) {
                      assets1.push(results.data.listSPUserDetails.items);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                  });
              }
              console.log(assets1);
              if (assets1.length > 0) {
                const mergeAssets1 = assets1.flat(1);
                console.log(mergeAssets1);
                const spDetails2 = mergeAssets1;
                const aoSP = spDetails2.filter((item) => {
                  const _matchSites = filtersitesss?.find(
                    (linkUser) => linkUser.userdetailsID === item?.id
                  );
                  if (_matchSites) {
                    return item;
                  }
                });
                console.log(aoSP);

                const filterSites = aoSP.filter(
                  (item) => item.id === selectedSiteGlobal
                );
                const sortedItems = aoSP.sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                });
                const sortedItems2 = aoSP.sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                });
                console.log(sortedItems);
                const SpUsers = sortedItems2;
                let PInvites = SpUsers.filter(
                  (item) => item.status === "Inactive"
                );
                let serviceProviders = [];
                console.log(PInvites);
                if (PInvites.length > 0) {
                  if (onDateRangeSelected === "This Week") {
                    serviceProviders = PInvites.filter(
                      (item) =>
                        moment(item.createdAt).format("DD/MM/YYYY") >=
                          moment(startOfWeek).format("DD/MM/YYYY") &&
                        moment(item.createdAt).format("DD/MM/YYYY") <=
                          moment(endOfWeek).format("DD/MM/YYYY")
                    );
                    //----Graph----------------------------------------
                    let unique = serviceProviders
                      .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      );
                    unique.map((uitem) => {
                      countsArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ).length
                      );
                    });
                    unique.map((uitem) => {
                      monthArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ) && uitem
                      );
                    });
                    setgraphLabelsPI(monthArray);
                    setgraphDataPI(countsArray);
                    //------------------------------end-------------------------------
                  } else if (onDateRangeSelected === "This Month") {
                    serviceProviders = PInvites.filter(
                      (item) =>
                        moment(item.createdAt).format("DD/MM/YYYY") >=
                          moment(startOfMonth).format("DD/MM/YYYY") &&
                        moment(item.createdAt).format("DD/MM/YYYY") <=
                          moment(endOfMonth).format("DD/MM/YYYY")
                    );
                    //----Graph----------------------------------------
                    let unique = serviceProviders
                      .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      );
                    unique.map((uitem) => {
                      countsArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ).length
                      );
                    });
                    unique.map((uitem) => {
                      monthArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ) && uitem
                      );
                    });
                    setgraphLabelsPI(monthArray);
                    setgraphDataPI(countsArray);
                    //------------------------------end-------------------------------
                  } else if (onDateRangeSelected === "Today") {
                    serviceProviders = PInvites.filter(
                      (item) =>
                        moment(item.createdAt).format("DD/MM/YYYY") ===
                        moment(new Date()).format("DD/MM/YYYY")
                    );
                    //----Graph----------------------------------------
                    let unique = serviceProviders
                      .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      );
                    unique.map((uitem) => {
                      countsArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ).length
                      );
                    });
                    unique.map((uitem) => {
                      monthArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ) && uitem
                      );
                    });
                    setgraphLabelsPI(monthArray);
                    setgraphDataPI(countsArray);
                    //------------------------------end-------------------------------
                  } else if (onDateRangeSelected === "This Year") {
                    serviceProviders = PInvites.filter(
                      (item) =>
                        moment(item.createdAt).format("DD/MM/YYYY") >=
                          moment(startOfThisYear).format("YYYY-MM-DD") &&
                        moment(item.createdAt).format("DD/MM/YYYY") <=
                          moment(endOfThisYear).format("DD/MM/YYYY")
                    );
                    //----Graph----------------------------------------
                    let unique = serviceProviders
                      .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      );
                    unique.map((uitem) => {
                      countsArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ).length
                      );
                    });
                    unique.map((uitem) => {
                      monthArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ) && uitem
                      );
                    });
                    setgraphLabelsPI(monthArray);
                    setgraphDataPI(countsArray);
                    //------------------------------end-------------------------------
                  } else if (onDateRangeSelected === "Custom") {
                    serviceProviders = PInvites.filter(
                      (item) =>
                        moment(item.createdAt).format("DD/MM/YYYY") >=
                          moment(startDate).format("DD/MM/YYYY") &&
                        moment(item.createdAt).format("DD/MM/YYYY") <=
                          moment(endDate).format("DD/MM/YYYY")
                    );
                    //----Graph----------------------------------------
                    let unique = serviceProviders
                      .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      );
                    unique.map((uitem) => {
                      countsArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ).length
                      );
                    });
                    unique.map((uitem) => {
                      monthArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ) && uitem
                      );
                    });
                    setgraphLabelsPI(monthArray);
                    setgraphDataPI(countsArray);
                    //------------------------------end-------------------------------
                  } else if (onDateRangeSelected === "All Time") {
                    serviceProviders = PInvites;
                    //----Graph----------------------------------------
                    let unique = serviceProviders
                      .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      );
                    unique.map((uitem) => {
                      countsArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ).length
                      );
                    });
                    unique.map((uitem) => {
                      monthArray.push(
                        serviceProviders.filter(
                          (d) =>
                            moment(d.createdAt).format("YYYY-MMM") === uitem
                        ) && uitem
                      );
                    });
                    setgraphLabelsPI(monthArray);
                    setgraphDataPI(countsArray);
                    //------------------------------end-------------------------------
                  }
                  setAssetOwnerDetailsList(serviceProviders);
                  const oneYearAgo = new Date();
                  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
                  const val = serviceProviders.filter(
                    (item) =>
                      moment(item.createdAt).format("DD/MM/YYYY") ===
                      moment(new Date()).format("DD/MM/YYYY")
                  );
                  setIsLoading(false);
                } else {
                  setAssetOwnerDetailsList([]);
                  setIsLoading(false);
                }
              }
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    return () => client.cancel();
    // p invite ends
  }

  //--------------Pending Invitations End----------------------------------------------------
  async function fetchAssets(sites, onDateRangeSelected) {
    //---Week--
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const startOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDayOfWeek
    );
    const endOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDayOfWeek)
    );
    // ---Month
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    // ---year
    const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
    const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
    //---custom -----
    const [startDate, endDate] = dateRange;
    let assetsCount = [];
    let countsArray = [];
    let monthArray = [];
    setIsLoading(true);
    let assets = [];
    let testing = [];
    let repair = [];
    let filter = {};
    if (onDateRangeSelected === "Today") {
      filter = {
        createdAt: {
          ge: moment().startOf("day").toISOString(),
          le: moment().endOf("day").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "This Week") {
      filter = {
        createdAt: {
          ge: moment().startOf("week").toISOString(),
          le: moment().endOf("week").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "This Month") {
      filter = {
        createdAt: {
          ge: moment().startOf("month").toISOString(),
          le: moment().endOf("month").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "This Year") {
      filter = {
        createdAt: {
          ge: moment().startOf("year").toISOString(),
          le: moment().endOf("year").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "Custom") {
      filter = {
        createdAt: {
          ge: moment(startDate).startOf("day").toISOString(),
          le: moment(endDate).endOf("day").toISOString(),
        },
      };
    }
    console.log("filter", filter);
    try {
      //console.log(sites);
      console.log(assetsCount);
      let nextToken = "";
      let sites = [];
      await client
        .graphql({
          query: queries.assetsByAssetOwnerID,
          variables: {
            assetOwnerID: LoginUserDetails.id,
            filter: filter,
            limit: 200000,
          },
          authMode: "API_KEY",
        })
        .then(async (result) => {
          let assetDatas = result.data.assetsByAssetOwnerID.items;
          nextToken = result.data.assetsByAssetOwnerID.nextToken;
          if (result.data.assetsByAssetOwnerID.items.length > 0) {
            sites.push(assetDatas);
          }
          while (nextToken !== null) {
            await client
              .graphql({
                query: queries.assetsByAssetOwnerID,
                variables: {
                  assetOwnerID: LoginUserDetails.id,
                  limit: 200000,
                  filter: filter,
                  nextToken: nextToken,
                },
                authMode: "API_KEY",
              })
              .then((results) => {
                nextToken = results.data.assetsByAssetOwnerID.nextToken;
                if (results.data.assetsByAssetOwnerID.items.length > 0) {
                  sites.push(results.data.assetsByAssetOwnerID.items);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(sites);
          if (sites.length > 0) {
            const mergeSites = sites.flat(1);
            console.log(mergeSites);

            //---
            if (onDateRangeSelected === "All Time") {
              //----Graph----------------------------------------
              let unique = mergeSites
                .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                .filter((value, index, self) => self.indexOf(value) === index);
              unique.map((uitem) => {
                countsArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ).length
                );
              });
              unique.map((uitem) => {
                monthArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ) && uitem
                );
              });
              setgraphLabelsAssets(monthArray);
              setgraphDataAssets(countsArray);
              //------------------graph-------------------end---------------
            } else if (onDateRangeSelected === "This Week") {
              //----Graph----------------------------------------
              let unique = mergeSites
                .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                .filter((value, index, self) => self.indexOf(value) === index);
              unique.map((uitem) => {
                countsArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ).length
                );
              });
              unique.map((uitem) => {
                monthArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ) && uitem
                );
              });
              setgraphLabelsAssets(monthArray);
              setgraphDataAssets(countsArray);
              //------------------graph-------------------end---------------
            } else if (onDateRangeSelected === "This Month") {
              //----Graph----------------------------------------
              let unique = mergeSites
                .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                .filter((value, index, self) => self.indexOf(value) === index);
              unique.map((uitem) => {
                countsArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ).length
                );
              });
              unique.map((uitem) => {
                monthArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ) && uitem
                );
              });
              setgraphLabelsAssets(monthArray);
              setgraphDataAssets(countsArray);
              //------------------graph-------------------end---------------
            } else if (onDateRangeSelected === "Today") {
              //----Graph----------------------------------------
              let unique = mergeSites
                .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                .filter((value, index, self) => self.indexOf(value) === index);
              unique.map((uitem) => {
                countsArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ).length
                );
              });
              unique.map((uitem) => {
                monthArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ) && uitem
                );
              });
              setgraphLabelsAssets(monthArray);
              setgraphDataAssets(countsArray);
              //------------------graph-------------------end---------------
            } else if (onDateRangeSelected === "This Year") {
              //----Graph----------------------------------------
              let unique = mergeSites
                .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                .filter((value, index, self) => self.indexOf(value) === index);
              unique.map((uitem) => {
                countsArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ).length
                );
              });
              unique.map((uitem) => {
                monthArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ) && uitem
                );
              });
              setgraphLabelsAssets(monthArray);
              setgraphDataAssets(countsArray);
              //------------------graph-------------------end---------------
            } else if (onDateRangeSelected === "Custom") {
              //----Graph----------------------------------------
              let unique = mergeSites
                .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                .filter((value, index, self) => self.indexOf(value) === index);
              unique.map((uitem) => {
                countsArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ).length
                );
              });
              unique.map((uitem) => {
                monthArray.push(
                  mergeSites.filter(
                    (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                  ) && uitem
                );
              });
              setgraphLabelsAssets(monthArray);
              setgraphDataAssets(countsArray);
              //------------------graph-------------------end---------------
            }
            setAssetsCount(mergeSites.length);
          } else {
            setAssetsCount([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    return () => client.cancel();
  }

  //--------------Sites start-------------------------------------------------------------------
  async function fetchSitesDetails(onDateRangeSelected) {
    //---Week--
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const startOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDayOfWeek
    );
    const endOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDayOfWeek)
    );
    // ---Month
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    // ---year
    const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
    const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
    //---custom -----
    const [startDate, endDate] = dateRange;
    let sitesCount = [];
    let monthArray = [];
    let countsArray = [];
    setIsLoading(true);
    let nextToken = "";
    let sitess = [];
    try {
      const variables = {
        status: "",
        onDateRange: onDateRangeSelected,
        assetOwnerID: LoginUserDetails.id,
      };

      const results = await client.graphql({
        query: queries.getSiteSummary,
        variables,
        authMode: "API_KEY",
      });

      const result = results.data.getSiteSummary;
      console.log("Site count response:", result);
      SiteData.setSiteData(result.sites);
      if (result.sites.length > 0) {
        const siteIDs = result.sites.map((site) => site.id);
        const mergeSites = result.sites.flat(1);
        console.log("total Sites", mergeSites);
        if (mergeSites.length > 0) {
          const siteFilter = mergeSites.filter(
            (item) => item.id === selectedSiteGlobal
          );
          console.log(siteFilter);
          const NewSite = siteFilter.length > 0 ? siteFilter : mergeSites;
          //---testing data for other filters
          if (onDateRangeSelected !== "All Time") {
            console.log("not all time");
            //fetchTestingDetails(NewSite, onDateRangeSelected);
            //fetchRepairDetails(NewSite, onDateRangeSelected);
          }
          console.log("onDateRangeSelected", onDateRangeSelected);
          if (onDateRangeSelected === "All Time") {
            sitesCount = NewSite.filter((item) => !item._delete);
            //----Graph----------------------------------------
            let unique = sitesCount
              .map((item) => moment(item.createdAt).format("YYYY-MMM"))
              .filter((value, index, self) => self.indexOf(value) === index);
            unique.map((uitem) => {
              countsArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ).length
              );
            });
            unique.map((uitem) => {
              monthArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ) && uitem
              );
            });
            setgraphLabelsSites(monthArray);
            setgraphDataSites(countsArray);
            //------------------graph-------------------end---------------
          } else if (onDateRangeSelected === "This Week") {
            sitesCount = NewSite.filter((item) => {
              const createdAtDate = moment(item.createdAt);
              return (
                createdAtDate.isSameOrAfter(
                  moment(startOfWeek, "DD/MM/YYYY"),
                  "day"
                ) &&
                createdAtDate.isSameOrBefore(
                  moment(endOfWeek, "DD/MM/YYYY"),
                  "day"
                )
              );
            });
            //----Graph----------------------------------------
            let unique = sitesCount
              .map((item) => moment(item.createdAt).format("YYYY-MMM"))
              .filter((value, index, self) => self.indexOf(value) === index);
            unique.map((uitem) => {
              countsArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ).length
              );
            });
            unique.map((uitem) => {
              monthArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ) && uitem
              );
            });
            setgraphLabelsSites(monthArray);
            setgraphDataSites(countsArray);
          } else if (onDateRangeSelected === "This Month") {
            sitesCount = NewSite.filter((item) => {
              const createdAtDate = moment(item.createdAt);
              return createdAtDate.isBetween(
                moment(startOfMonth, "DD/MM/YYYY"),
                moment(endOfMonth, "DD/MM/YYYY"),
                null,
                "[]"
              );
            });
            //----Graph----------------------------------------
            let unique = sitesCount
              .map((item) => moment(item.createdAt).format("YYYY-MMM"))
              .filter((value, index, self) => self.indexOf(value) === index);
            unique.map((uitem) => {
              countsArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ).length
              );
            });
            unique.map((uitem) => {
              monthArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ) && uitem
              );
            });
            setgraphLabelsSites(monthArray);
            setgraphDataSites(countsArray);
            //--------------------------------------------------------
          } else if (onDateRangeSelected === "Today") {
            sitesCount = NewSite.filter(
              (item) =>
                moment(item.createdAt).format("DD/MM/YYYY") ===
                moment(new Date()).format("DD/MM/YYYY")
            );
            //----Graph----------------------------------------
            let unique = sitesCount
              .map((item) => moment(item.createdAt).format("YYYY-MMM"))
              .filter((value, index, self) => self.indexOf(value) === index);
            unique.map((uitem) => {
              countsArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ).length
              );
            });
            unique.map((uitem) => {
              monthArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ) && uitem
              );
            });
            setgraphLabelsSites(monthArray);
            setgraphDataSites(countsArray);
            //------------------------------end-------------------------------
          } else if (onDateRangeSelected === "Custom") {
            sitesCount = NewSite.filter(
              (item) =>
                moment(item.createdAt).format("DD/MM/YYYY") >=
                  moment(startDate).format("DD/MM/YYYY") &&
                moment(item.createdAt).format("DD/MM/YYYY") <=
                  moment(endDate).format("DD/MM/YYYY")
            );
            //----Graph----------------------------------------
            let unique = sitesCount
              .map((item) => moment(item.createdAt).format("YYYY-MMM"))
              .filter((value, index, self) => self.indexOf(value) === index);
            unique.map((uitem) => {
              countsArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ).length
              );
            });
            unique.map((uitem) => {
              monthArray.push(
                sitesCount.filter(
                  (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                ) && uitem
              );
            });
            setgraphLabelsSites(monthArray);
            setgraphDataSites(countsArray);
            //------------------------------end-------------------------------
          }
          console.log(sitesCount);
          setIsLoading(false);
          setSiteDetails(sitesCount);
        } else {
          setSiteDetails([]);
        }
      } else {
        setIsLoading(false);
        setSiteDetails([]);
      }
    } catch (error) {
      console.log(error);
    }
    // await client
    //   .graphql({
    //     query: queries.siteDetailsByAssetownerID,
    //     variables: {
    //       assetownerID: LoginUserDetails.id,
    //       limit: 200000,
    //     },
    //     authMode: "API_KEY",
    //   })
    //   .then(async (result) => {
    //     let assetDatas = result.data.siteDetailsByAssetownerID.items;
    //     nextToken = result.data.siteDetailsByAssetownerID.nextToken;
    //     if (result.data.siteDetailsByAssetownerID.items.length > 0) {
    //       sitess.push(assetDatas);
    //     }
    //     while (nextToken !== null) {
    //       await client
    //         .graphql({
    //           query: queries.siteDetailsByAssetownerID,
    //           variables: {
    //             assetownerID: LoginUserDetails.id,
    //             limit: 200000,
    //             nextToken: nextToken,
    //           },
    //           authMode: "API_KEY",
    //         })
    //         .then((results) => {
    //           nextToken = results.data.siteDetailsByAssetownerID.nextToken;
    //           if (results.data.siteDetailsByAssetownerID.items.length > 0) {
    //             sitess.push(results.data.siteDetailsByAssetownerID.items);
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //         });
    //     }
    //     console.log(sitess);
    //     if (sitess.length > 0) {
    //       const mergeSites = sitess.flat(1);
    //       const sitesss = mergeSites;
    //       if (sitesss.length > 0) {
    //         const siteFilter = sitesss.filter(
    //           (item) => item.id === selectedSiteGlobal
    //         );
    //         console.log(siteFilter);
    //         const NewSite = siteFilter.length > 0 ? siteFilter : mergeSites;
    //         //---testing data for other filters
    //         if (onDateRangeSelected !== "All Time") {
    //           console.log("not all time");
    //           fetchTestingDetails(NewSite, onDateRangeSelected);
    //           fetchRepairDetails(NewSite, onDateRangeSelected);
    //         }
    //         console.log("onDateRangeSelected", onDateRangeSelected);
    //         if (onDateRangeSelected === "All Time") {
    //           sitesCount = NewSite.filter((item) => !item._delete);
    //           //----Graph----------------------------------------
    //           let unique = sitesCount
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsSites(monthArray);
    //           setgraphDataSites(countsArray);
    //           //------------------graph-------------------end---------------
    //         } else if (onDateRangeSelected === "This Week") {
    //           sitesCount = NewSite.filter((item) => {
    //             const createdAtDate = moment(item.createdAt);
    //             return (
    //               createdAtDate.isSameOrAfter(
    //                 moment(startOfWeek, "DD/MM/YYYY"),
    //                 "day"
    //               ) &&
    //               createdAtDate.isSameOrBefore(
    //                 moment(endOfWeek, "DD/MM/YYYY"),
    //                 "day"
    //               )
    //             );
    //           });
    //           //----Graph----------------------------------------
    //           let unique = sitesCount
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsSites(monthArray);
    //           setgraphDataSites(countsArray);
    //         } else if (onDateRangeSelected === "This Month") {
    //           sitesCount = NewSite.filter((item) => {
    //             const createdAtDate = moment(item.createdAt);
    //             return createdAtDate.isBetween(
    //               moment(startOfMonth, "DD/MM/YYYY"),
    //               moment(endOfMonth, "DD/MM/YYYY"),
    //               null,
    //               "[]"
    //             );
    //           });
    //           //----Graph----------------------------------------
    //           let unique = sitesCount
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsSites(monthArray);
    //           setgraphDataSites(countsArray);
    //           //--------------------------------------------------------
    //         } else if (onDateRangeSelected === "Today") {
    //           sitesCount = NewSite.filter(
    //             (item) =>
    //               moment(item.createdAt).format("DD/MM/YYYY") ===
    //               moment(new Date()).format("DD/MM/YYYY")
    //           );
    //           //----Graph----------------------------------------
    //           let unique = sitesCount
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsSites(monthArray);
    //           setgraphDataSites(countsArray);
    //           //------------------------------end-------------------------------
    //         } else if (onDateRangeSelected === "This Year") {
    //           sitesCount = NewSite.filter((item) => {
    //             const createdAtDate = moment(item.createdAt);
    //             return createdAtDate.isBetween(
    //               moment(startOfThisYear, "DD/MM/YYYY"),
    //               moment(endOfThisYear, "DD/MM/YYYY"),
    //               null,
    //               "[]"
    //             );
    //           });
    //           //----Graph----------------------------------------
    //           let unique = sitesCount
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsSites(monthArray);
    //           setgraphDataSites(countsArray);
    //           //------------------------------end-------------------------------
    //         } else if (onDateRangeSelected === "Custom") {
    //           sitesCount = NewSite.filter(
    //             (item) =>
    //               moment(item.createdAt).format("DD/MM/YYYY") >=
    //               moment(startDate).format("DD/MM/YYYY") &&
    //               moment(item.createdAt).format("DD/MM/YYYY") <=
    //               moment(endDate).format("DD/MM/YYYY")
    //           );
    //           //----Graph----------------------------------------
    //           let unique = sitesCount
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               sitesCount.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsSites(monthArray);
    //           setgraphDataSites(countsArray);
    //           //------------------------------end-------------------------------
    //         }
    //         console.log(sitesCount);
    //         fetchLogbookDetails(sitesCount, onDateRangeSelected);
    //         setIsLoading(false);
    //         setSiteDetails(sitesCount);
    //       } else {
    //         setSiteDetails([]);
    //         fetchLogbookDetails([], onDateRangeSelected);
    //       }
    //     } else {
    //       setSiteDetails([]);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    return () => client.cancel();
  }
  //--- Sites End ----

  //--- Service provider Start ----
  // async function fetchServiceProviderDetails(onDateRangeSelected) {
  //   //---Week--
  //   const currentDate = new Date();
  //   const currentDayOfWeek = currentDate.getDay();
  //   const startOfWeek = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     currentDate.getDate() - currentDayOfWeek
  //   );
  //   const endOfWeek = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     currentDate.getDate() + (6 - currentDayOfWeek)
  //   );
  //   // ---Month
  //   const startOfMonth = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     1
  //   );
  //   const endOfMonth = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth() + 1,
  //     0
  //   );
  //   // ---year
  //   const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
  //   const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
  //   //---custom -----
  //   const [startDate, endDate] = dateRange;
  //   let monthArray = [];
  //   let countsArray = [];
  //   setIsLoading(true);
  //   let serviceProviders = [];
  //   let siteUserDetails = [];
  //   let monthArray1 = [];
  //   let countsArray1 = [];
  //   let userIds = [];
  //   let nextToken1 = "";
  //   const filterSites = fullSites.filter(
  //     (item) => item.id === selectedSiteGlobal
  //   );
  //   const filtersitesss = selectedSiteGlobal ? filterSites : fullSites;
  //   console.log(filtersitesss);
  //   if (filtersitesss.length > 0) {
  //     let count = 0;
  //     for (let site of filtersitesss) {
  //       count = count + 1;
  //       const getSiteIds = await client.graphql({
  //         query: queries.linkUsersAndSitesBySitedetailsID,
  //         authMode: "API_KEY",
  //         variables: {
  //           sitedetailsID: site.id,
  //           // filter: {
  //           //   status: {
  //           //     eq: "Active"
  //           //   }
  //           // },
  //         },
  //       });
  //       console.log(getSiteIds);
  //       if (
  //         getSiteIds.data.linkUsersAndSitesBySitedetailsID.items.length > 0
  //       ) {
  //         nextToken1 =
  //           getSiteIds.data.linkUsersAndSitesBySitedetailsID.nextToken;
  //         userIds.push(
  //           getSiteIds.data.linkUsersAndSitesBySitedetailsID.items
  //         );
  //         while (nextToken1 !== null) {
  //           const getSiteIds1 = await client.graphql({
  //             query: queries.linkUsersAndSitesBySitedetailsID,
  //             authMode: "API_KEY",
  //             variables: {
  //               sitedetailsID: site.id,
  //               // filter: {
  //               //   status: {
  //               //     eq: "Active"
  //               //   }
  //               // },
  //               nextToken: nextToken1,
  //             },
  //           });
  //           console.log(getSiteIds1);
  //           if (
  //             getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items
  //               .length > 0
  //           ) {
  //             nextToken1 =
  //               getSiteIds1.data.linkUsersAndSitesBySitedetailsID.nextToken;
  //             userIds.push(
  //               getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items
  //             );
  //           }
  //           else {
  //             nextToken1 = null;
  //           }
  //         }
  //       }
  //     }
  //     console.log(userIds);
  //     if (count === filtersitesss.length) {
  //       if (userIds.length > 0) {
  //         const mergeUserIds = userIds.flat(1);
  //         const response1 = await client.graphql({
  //           query: queries.listSPUserDetails,
  //           authMode: "API_KEY",
  //           variables: {
  //             filter: {
  //               userGroup: {
  //                 eq: "electrician",
  //               },
  //             },
  //             limit: 200000,
  //           },
  //         });
  //         if (response1.data.listSPUserDetails.items.length > 0) {
  //           const spDetails2 = response1.data.listSPUserDetails.items.filter(
  //             (item) => {
  //               const _matchSites = mergeUserIds?.find(
  //                 (user) => user.userdetailsID === item?.id
  //               );
  //               if (_matchSites) {
  //                 return item;
  //               }
  //             }
  //           );
  //           console.log(spDetails2);
  //           const sortedItems = spDetails2.sort((a, b) => {
  //             return new Date(b.createdAt) - new Date(a.createdAt);
  //           });
  //           console.log(sortedItems);
  //           const spDetails1 = sortedItems;
  //           console.log(spDetails1);

  //           if (spDetails1.length > 0) {
  //             if (spDetails1.length > 0) {
  //               console.log(spDetails);
  //               const filterSites = spDetails1.filter(
  //                 (item) => item.sitedetailsID === selectedSiteGlobal
  //               );
  //               const spDetails = selectedSiteGlobal ? filterSites : spDetails;
  //               const electrician = spDetails.filter(
  //                 (item) => item.userGroup === "electrician"
  //               );
  //               console.log("sp user", electrician);
  //               if (onDateRangeSelected === "This Week") {
  //                 serviceProviders = electrician.filter((item) => {
  //                   const createdAtDate = moment(item.createdAt);
  //                   return (
  //                     createdAtDate.isSameOrAfter(
  //                       moment(startOfWeek, "DD/MM/YYYY"),
  //                       "day"
  //                     ) &&
  //                     createdAtDate.isSameOrBefore(
  //                       moment(endOfWeek, "DD/MM/YYYY"),
  //                       "day"
  //                     )
  //                   );
  //                 });
  //                 //----Graph----------------------------------------
  //                 let unique = serviceProviders
  //                   .map((item) => moment(item.createdAt).format("YYYY-MMM"))
  //                   .filter((value, index, self) => self.indexOf(value) === index);
  //                 unique.map((uitem) => {
  //                   countsArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ).length
  //                   );
  //                 });
  //                 unique.map((uitem) => {
  //                   monthArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ) && uitem
  //                   );
  //                 });
  //                 setgraphLabelsSP(monthArray);
  //                 setgraphDataSP(countsArray);
  //                 //------------------------------end-------------------------------
  //               } else if (onDateRangeSelected === "This Month") {
  //                 serviceProviders = electrician.filter((item) => {
  //                   const createdAtDate = moment(item.createdAt);
  //                   return createdAtDate.isBetween(
  //                     moment(startOfMonth, "DD/MM/YYYY"),
  //                     moment(endOfMonth, "DD/MM/YYYY"),
  //                     null,
  //                     "[]"
  //                   );
  //                 });
  //                 //----Graph----------------------------------------
  //                 let unique = serviceProviders
  //                   .map((item) => moment(item.createdAt).format("YYYY-MMM"))
  //                   .filter((value, index, self) => self.indexOf(value) === index);
  //                 unique.map((uitem) => {
  //                   countsArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ).length
  //                   );
  //                 });
  //                 unique.map((uitem) => {
  //                   monthArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ) && uitem
  //                   );
  //                 });
  //                 setgraphLabelsSP(monthArray);
  //                 setgraphDataSP(countsArray);
  //                 //------------------------------end-------------------------------
  //               } else if (onDateRangeSelected === "Today") {
  //                 serviceProviders = electrician.filter(
  //                   (item) =>
  //                     moment(item.createdAt).format("DD/MM/YYYY") ===
  //                     moment(new Date()).format("DD/MM/YYYY")
  //                 );
  //                 //----Graph----------------------------------------
  //                 let unique = serviceProviders
  //                   .map((item) => moment(item.createdAt).format("YYYY-MMM"))
  //                   .filter((value, index, self) => self.indexOf(value) === index);
  //                 unique.map((uitem) => {
  //                   countsArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ).length
  //                   );
  //                 });
  //                 unique.map((uitem) => {
  //                   monthArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ) && uitem
  //                   );
  //                 });
  //                 setgraphLabelsSP(monthArray);
  //                 setgraphDataSP(countsArray);
  //                 //------------------------------end-------------------------------
  //               } else if (onDateRangeSelected === "This Year") {
  //                 serviceProviders = electrician.filter((item) => {
  //                   const createdAtDate = moment(item.createdAt);
  //                   return createdAtDate.isBetween(
  //                     moment(startOfThisYear, "DD/MM/YYYY"),
  //                     moment(endOfThisYear, "DD/MM/YYYY"),
  //                     null,
  //                     "[]"
  //                   );
  //                 });
  //                 //----Graph----------------------------------------
  //                 let unique = serviceProviders
  //                   .map((item) => moment(item.createdAt).format("YYYY-MMM"))
  //                   .filter((value, index, self) => self.indexOf(value) === index);
  //                 unique.map((uitem) => {
  //                   countsArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ).length
  //                   );
  //                 });
  //                 unique.map((uitem) => {
  //                   monthArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ) && uitem
  //                   );
  //                 });
  //                 setgraphLabelsSP(monthArray);
  //                 setgraphDataSP(countsArray);
  //                 //------------------------------end-------------------------------
  //               } else if (onDateRangeSelected === "Custom") {
  //                 serviceProviders = electrician.filter(
  //                   (item) =>
  //                     moment(item.createdAt).format("DD/MM/YYYY") >=
  //                     moment(startDate).format("DD/MM/YYYY") &&
  //                     moment(item.createdAt).format("DD/MM/YYYY") <=
  //                     moment(endDate).format("DD/MM/YYYY")
  //                 );
  //                 //----Graph----------------------------------------
  //                 let unique = serviceProviders
  //                   .map((item) => moment(item.createdAt).format("YYYY-MMM"))
  //                   .filter((value, index, self) => self.indexOf(value) === index);
  //                 unique.map((uitem) => {
  //                   countsArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ).length
  //                   );
  //                 });
  //                 unique.map((uitem) => {
  //                   monthArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ) && uitem
  //                   );
  //                 });
  //                 setgraphLabelsSP(monthArray);
  //                 setgraphDataSP(countsArray);
  //                 //------------------------------end-------------------------------
  //               } else if (onDateRangeSelected === "All Time") {
  //                 serviceProviders = electrician;
  //                 //----Graph----------------------------------------
  //                 let unique = serviceProviders
  //                   .map((item) => moment(item.createdAt).format("YYYY-MMM"))
  //                   .filter((value, index, self) => self.indexOf(value) === index);
  //                 unique.map((uitem) => {
  //                   countsArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ).length
  //                   );
  //                 });
  //                 unique.map((uitem) => {
  //                   monthArray.push(
  //                     serviceProviders.filter(
  //                       (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
  //                     ) && uitem
  //                   );
  //                 });
  //                 setgraphLabelsSP(monthArray);
  //                 setgraphDataSP(countsArray);
  //                 //------------------------------end-------------------------------
  //               }
  //               console.log("filter sp user", serviceProviders);
  //               setlistofServiceProviders(serviceProviders);
  //               setIsLoading(false);
  //             }
  //           }
  //         }
  //       } else {
  //         setIsLoading(false);
  //       }
  //     }
  //   } else {
  //     setIsLoading(false);
  //   }

  //   return () => client.cancel();
  // }

  async function fetchServiceProviderDetails(onDateRangeSelected) {
    try {
      if (fullSites.length > 0) {
        const siteIds = fullSites
          .filter((site) => site.status === "Active")
          .map((site) => site.id);

        console.log("fullSites", fullSites);

        // Helper function to chunk arrays
        const chunkArray = (arr, size) => {
          const chunks = [];
          for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
          }
          return chunks;
        };

        const siteIdChunks = chunkArray(siteIds, 50);
        let combinedSummaries = { site_user: [], electrician: [] };

        for (const chunk of siteIdChunks) {
          console.log(`Processing chunk of ${chunk.length} siteIds`);

          const results = await client.graphql({
            query: queries.getSiteUsersAndElectricians,
            variables: {
              siteIds: chunk,
              onDateRange: onDateRangeSelected,
            },
            authMode: "API_KEY",
          });

          const summaries = results.data.getSiteUsersAndElectricians;

          if (summaries) {
            combinedSummaries.site_user.push(...(summaries.site_user || []));
            combinedSummaries.electrician.push(
              ...(summaries.electrician || [])
            );
          }
        }

        console.log("Combined summaries", combinedSummaries);

        const siteUsers = combinedSummaries.site_user || [];
        const electricians = combinedSummaries.electrician || [];

        // --- Deduplicate users ---
        const uniqueSiteUsers = Array.from(
          new Map(
            siteUsers.map((user) => [user.id || user.userID, user])
          ).values()
        );

        const uniqueElectricians = Array.from(
          new Map(
            electricians.map((user) => [user.id || user.userID, user])
          ).values()
        );

        console.log("Site Users:", uniqueSiteUsers.length);
        const suInvitedBy = uniqueSiteUsers.filter(
          (item) => item.invitedBy === LoginUserDetails.id
        );
        console.log("sudataa", suInvitedBy);
        console.log("Electricians:", uniqueElectricians.length);

        setListofSiteUsers(suInvitedBy);
        setlistofServiceProviders(uniqueElectricians.length);

        return combinedSummaries;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching user summaries:", error);
      return [];
    }
  }
  //--- Service provider End ----
  //--- Testing Start ----
  async function fetchTestingDetails(testingData, onDateRangeSelected) {
    //---Week--
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const startOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDayOfWeek
    );
    const endOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDayOfWeek)
    );
    // ---Month
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    // ---year
    const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
    const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
    //---custom -----
    const [startDate, endDate] = dateRange;
    let testingDetails = [];
    let monthArray = [];
    let countsArray = [];
    setIsLoading(true);
    let filter = {};
    console.log("onDateRangeSelected", onDateRangeSelected);
    if (onDateRangeSelected === "Today") {
      filter = {
        createdAt: {
          ge: moment().startOf("day").toISOString(),
          lt: moment().endOf("day").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "This Week") {
      filter = {
        createdAt: {
          ge: moment().startOf("week").toISOString(),
          lt: moment().endOf("week").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "This Month") {
      filter = {
        createdAt: {
          ge: moment().startOf("month").toISOString(),
          lt: moment().endOf("month").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "This Year") {
      filter = {
        createdAt: {
          ge: moment().startOf("year").toISOString(),
          lt: moment().endOf("year").toISOString(),
        },
      };
    } else if (onDateRangeSelected === "Custom") {
      filter = {
        createdAt: {
          ge: moment(startDate).startOf("day").toISOString(),
          lt: moment(endDate).endOf("day").toISOString(),
        },
      };
    }
    console.log("filter", filter);
    console.log(testingData);
    let nextToken2 = "";
    let assets2 = [];

    if (!testingData || testingData.length === 0) {
      setTestingDetailsList(0);
      return;
    }
    console.log("dates", dateRange);
    console.log("custome");
    const activesites = testingData.filter((item) => item.status === "Active");
    const siteIds = activesites.map((asset) => asset.id);
    console.log("sitesIds", siteIds);

    const chunkSize = 50;
    const chunks = [];
    for (let i = 0; i < siteIds.length; i += chunkSize) {
      chunks.push(siteIds.slice(i, i + chunkSize));
    }

    try {
      const allResults = [];

      for (const chunk of chunks) {
        console.log("Fetching chunk:", chunk);
        const result = await client.graphql({
          query: queries.getTestingCountSummary,
          variables: {
            onDateRange: onDateRangeSelected,
            siteIds: chunk,
          },
          authMode: "API_KEY",
        });

        if (result.data?.getTestingCountSummary) {
          allResults.push(...result.data.getTestingCountSummary);
        }
      }
      console.log("Merged results:", allResults);

      const mergedAssets = activesites.map((asset) => {
        const summary = allResults.find((s) => s.sitedetailsID === asset.id);
        return {
          ...asset,
          totalTests: summary ? summary.totalTests : 0,
        };
      });

      const totalCount = mergedAssets.reduce(
        (sum, item) => sum + (item.totalTests || 0),
        0
      );

      console.log("Total Tests:", totalCount);
      setTestingDetailsList(totalCount);
    } catch (error) {
      console.error("Error fetching testing summary:", error);
      setTestingDetailsList(0);
    }
    // testingData.map(async (item) => {
    //   await client
    //     .graphql({
    //       query: queries.testingsBySitedetailsID,
    //       variables: {
    //         sitedetailsID: item.id,
    //         filter: filter,
    //         limit: 1000,
    //       },
    //       authMode: "API_KEY",
    //     })
    //     .then(async (result) => {
    //       let assetDatas = result.data.testingsBySitedetailsID.items;
    //       nextToken2 = result.data.testingsBySitedetailsID.nextToken;
    //       if (result.data.testingsBySitedetailsID.items.length > 0) {
    //         assets2.push(assetDatas);
    //       }
    //       while (nextToken2 !== null) {
    //         await client
    //           .graphql({
    //             query: queries.testingsBySitedetailsID,
    //             variables: {
    //               sitedetailsID: item.id,
    //               filter: filter,
    //               limit: 1000,
    //               nextToken: nextToken2,
    //             },
    //             authMode: "API_KEY",
    //           })
    //           .then((results) => {
    //             nextToken2 = results.data.testingsBySitedetailsID.nextToken;
    //             if (results.data.testingsBySitedetailsID.items.length > 0) {
    //               assets2.push(results.data.testingsBySitedetailsID.items);
    //             }
    //           })
    //           .catch((error) => {
    //             console.log(error);
    //           });
    //       }
    //       if (assets2.length > 0) {
    //         const mergeAssets2 = assets2.flat(1);
    //         testingDetails = mergeAssets2;
    //         console.log("test data", testingDetails);
    //         if (onDateRangeSelected === "All Time") {
    //           // testingDetails = testingData.filter((item) => !item._delete);
    //           //----Graph----------------------------------------
    //           let unique = testingDetails
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsTests(monthArray);
    //           setgraphDataTests(countsArray);
    //           //------------------graph-------------------end---------------
    //         } else if (onDateRangeSelected === "This Week") {
    //           //----Graph----------------------------------------
    //           let unique = testingDetails
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsTests(monthArray);
    //           setgraphDataTests(countsArray);
    //           //------------------graph-------------------end---------------
    //         } else if (onDateRangeSelected === "This Month") {
    //           //----Graph----------------------------------------
    //           let unique = testingDetails
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsTests(monthArray);
    //           setgraphDataTests(countsArray);
    //           //------------------graph-------------------end---------------
    //         } else if (onDateRangeSelected === "Today") {
    //           //----Graph----------------------------------------
    //           let unique = testingDetails
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsTests(monthArray);
    //           setgraphDataTests(countsArray);
    //           //------------------graph-------------------end---------------
    //         } else if (onDateRangeSelected === "This Year") {
    //           //----Graph----------------------------------------
    //           let unique = testingDetails
    //             .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //             .filter((value, index, self) => self.indexOf(value) === index);
    //           unique.map((uitem) => {
    //             countsArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ).length
    //             );
    //           });
    //           unique.map((uitem) => {
    //             monthArray.push(
    //               testingDetails.filter(
    //                 (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //               ) && uitem
    //             );
    //           });
    //           setgraphLabelsTests(monthArray);
    //           setgraphDataTests(countsArray);
    //           //------------------graph-------------------end---------------
    //         } else if (onDateRangeSelected === "Custom") {
    //         }
    //         setIsLoading(false);
    //         setTestingDetailsList(testingDetails);
    //       } else {
    //         setIsLoading(false);
    //         setTestingDetailsList([]);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // });
    return () => client.cancel();
  }

  //--- Testing Start ----
  async function fetchRepairDetails(sitesss, onDateRangeSelected) {
    setIsLoading(true);
    if (!sitesss || sitesss.length === 0) {
      setRepairDetailsList(0);
      return;
    }

    const activesites = sitesss.filter((item) => item.status === "Active");
    const siteIds = activesites.map((asset) => asset.id);
    console.log("sitesIds", siteIds);

    const chunkSize = 20;
    const chunks = [];
    for (let i = 0; i < siteIds.length; i += chunkSize) {
      chunks.push(siteIds.slice(i, i + chunkSize));
    }

    try {
      const allResults = [];
      setRepairDetailsList(0);
      for (const chunk of chunks) {
        console.log("Fetching repair chunk:", chunk);
        const result = await client.graphql({
          query: queries.getRepairSummary,
          variables: {
            onDateRange: onDateRangeSelected,
            siteIds: chunk,
          },
          authMode: "API_KEY",
        });

        if (result.data?.getRepairSummary) {
          allResults.push(...result.data.getRepairSummary);
        }
      }

      console.log("Merged repair results:", allResults);

      const mergedAssets = activesites.map((asset) => {
        const summary = allResults.find((s) => s.sitedetailsID === asset.id);
        return {
          ...asset,
          totalRepairs: summary ? summary.totalRepairs : 0,
        };
      });

      const totalCount = mergedAssets.reduce(
        (sum, item) => sum + (item.totalRepairs || 0),
        0
      );

      console.log("Total Repairs:", totalCount);
      setRepairDetailsList(totalCount);
    } catch (error) {
      console.error("Error fetching repair summary:", error);
      setRepairDetailsList(0);
    }
    // const dataDetails = await client.graphql({
    //   query: queries.listAssetTemplates,
    //   authMode: "API_KEY",
    //   variables: {
    //     limit: 200000,
    //   },
    // });
    // if (dataDetails.data.listAssetTemplates.items.length > 0) {
    //   let assetDatas = dataDetails.data.listAssetTemplates.items;
    //   nextToken = dataDetails.data.listAssetTemplates.nextToken;
    //   if (dataDetails.data.listAssetTemplates.items.length > 0) {
    //     assetTemplates.push(assetDatas);
    //   }
    //   while (nextToken !== null) {
    //     const dataDetailss = await client.graphql({
    //       query: queries.listAssetTemplates,
    //       variables: {
    //         limit: 200000,
    //         nextToken: nextToken,
    //       },
    //       authMode: "API_KEY",
    //     });
    //     if (dataDetailss.data.listAssetTemplates.items.length > 0) {
    //       nextToken = dataDetailss.data.listAssetTemplates.nextToken;
    //       if (dataDetailss.data.listAssetTemplates.items.length > 0) {
    //         assetTemplates.push(dataDetailss.data.listAssetTemplates.items);
    //       }
    //     }
    //   }
    //   console.log(assetTemplates);
    //   if (assetTemplates.length > 0) {
    //     const mergeAssetTemplates = assetTemplates.flat(1);
    //     let count = 0;
    //     //--
    //     for (let assetTemplate of mergeAssetTemplates) {
    //       count = count + 1;
    //       for (let sites of testingData) {
    //         let tempSiteId = assetTemplate.id + "_" + sites.id;
    //         await client
    //           .graphql({
    //             query: queries.repairsByAssettemplateSiteID,
    //             variables: {
    //               assettemplateSiteID: tempSiteId,
    //               filter: filter,
    //               limit: 1000,
    //             },
    //             authMode: "API_KEY",
    //           })
    //           .then(async (result) => {
    //             let assetDatas = result.data.repairsByAssettemplateSiteID.items;
    //             nextToken2 = result.data.repairsByAssettemplateSiteID.nextToken;
    //             if (result.data.repairsByAssettemplateSiteID.items.length > 0) {
    //               assets2.push(assetDatas);
    //             }
    //             while (nextToken2 !== null) {
    //               await client
    //                 .graphql({
    //                   query: queries.repairsByAssettemplateSiteID,
    //                   variables: {
    //                     assettemplateSiteID: tempSiteId,
    //                     filter: filter,
    //                     limit: 1000,
    //                     nextToken: nextToken2,
    //                   },
    //                   authMode: "API_KEY",
    //                 })
    //                 .then((results) => {
    //                   nextToken2 =
    //                     results.data.repairsByAssettemplateSiteID.nextToken;
    //                   if (
    //                     results.data.repairsByAssettemplateSiteID.items.length >
    //                     0
    //                   ) {
    //                     assets2.push(
    //                       results.data.repairsByAssettemplateSiteID.items
    //                     );
    //                   }
    //                 })
    //                 .catch((error) => {
    //                   console.log(error);
    //                 });
    //             }
    //           })
    //           .catch((error) => {
    //             console.log(error);
    //           });
    //       }
    //       if (count === mergeAssetTemplates.length) {
    //         if (assets2.length > 0) {
    //           const mergeAssets2 = assets2.flat(1);
    //           testingDetails = mergeAssets2;
    //           console.log("repair count", testingDetails);
    //           if (onDateRangeSelected === "All Time") {
    //             // testingDetails = testingData.filter((item) => !item._delete);
    //             //----Graph----------------------------------------
    //             let unique = testingDetails
    //               .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //               .filter(
    //                 (value, index, self) => self.indexOf(value) === index
    //               );
    //             unique.map((uitem) => {
    //               countsArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ).length
    //               );
    //             });
    //             unique.map((uitem) => {
    //               monthArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ) && uitem
    //               );
    //             });
    //             setgraphLabelsRepairs(monthArray);
    //             setgraphDataRepairs(countsArray);
    //             //------------------graph-------------------end---------------
    //           } else if (onDateRangeSelected === "This Week") {
    //             //----Graph----------------------------------------
    //             let unique = testingDetails
    //               .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //               .filter(
    //                 (value, index, self) => self.indexOf(value) === index
    //               );
    //             unique.map((uitem) => {
    //               countsArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ).length
    //               );
    //             });
    //             unique.map((uitem) => {
    //               monthArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ) && uitem
    //               );
    //             });
    //             setgraphLabelsRepairs(monthArray);
    //             setgraphDataRepairs(countsArray);
    //             //------------------graph-------------------end---------------
    //           } else if (onDateRangeSelected === "This Month") {
    //             //----Graph----------------------------------------
    //             let unique = testingDetails
    //               .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //               .filter(
    //                 (value, index, self) => self.indexOf(value) === index
    //               );
    //             unique.map((uitem) => {
    //               countsArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ).length
    //               );
    //             });
    //             unique.map((uitem) => {
    //               monthArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ) && uitem
    //               );
    //             });
    //             setgraphLabelsRepairs(monthArray);
    //             setgraphDataRepairs(countsArray);
    //             //------------------graph-------------------end---------------
    //           } else if (onDateRangeSelected === "Today") {
    //             //----Graph----------------------------------------
    //             let unique = testingDetails
    //               .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //               .filter(
    //                 (value, index, self) => self.indexOf(value) === index
    //               );
    //             unique.map((uitem) => {
    //               countsArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ).length
    //               );
    //             });
    //             unique.map((uitem) => {
    //               monthArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ) && uitem
    //               );
    //             });
    //             setgraphLabelsRepairs(monthArray);
    //             setgraphDataRepairs(countsArray);
    //             //------------------graph-------------------end---------------
    //           } else if (onDateRangeSelected === "This Year") {
    //             //----Graph----------------------------------------
    //             let unique = testingDetails
    //               .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //               .filter(
    //                 (value, index, self) => self.indexOf(value) === index
    //               );
    //             unique.map((uitem) => {
    //               countsArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ).length
    //               );
    //             });
    //             unique.map((uitem) => {
    //               monthArray.push(
    //                 testingDetails.filter(
    //                   (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                 ) && uitem
    //               );
    //             });
    //             setgraphLabelsRepairs(monthArray);
    //             setgraphDataRepairs(countsArray);
    //             //------------------graph-------------------end---------------
    //           } else if (onDateRangeSelected === "Custom") {
    //           }
    //           setIsLoading(false);
    //           setRepairDetailsList(testingDetails);
    //         } else {
    //           setIsLoading(false);
    //           setRepairDetailsList([]);
    //         }
    //       }
    //     }
    //   }
    // }

    return () => client.cancel();
  }
  //--- Testing End ----

  //--- SiteUser Start ----
  async function fetchSiteUserDetails(onDateRangeSelected) {
    //---Week--
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const startOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDayOfWeek
    );
    const endOfWeek = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDayOfWeek)
    );
    // ---Month
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    // ---year
    const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
    const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);

    //---custom -----

    const [startDate, endDate] = dateRange;
    var date1 = new Date().getDate();
    var month = new Date().getMonth();
    var year = new Date().getFullYear();

    let siteUserDetails = [];
    let countsArray = [];
    let monthArray = [];
    setIsLoading(true);

    //------------------------------------------------------
    console.log("ao related site user");

    let nextToken = "";
    let assets = [];
    // await client
    //   .graphql({
    //     query: queries.listLinkUsersAndSites,
    //     authMode: "API_KEY",
    //     variables: {
    //       limit: 20000,
    //       filter: {
    //         status: {
    //           eq: "Active",
    //         },
    //       },
    //     },
    //   })
    //   .then(async (result) => {
    //     let assetDatas = result.data.listLinkUsersAndSites.items;
    //     nextToken = result.data.listLinkUsersAndSites.nextToken;
    //     if (result.data.listLinkUsersAndSites.items.length > 0) {
    //       assets.push(assetDatas);
    //     }
    //     while (nextToken !== null) {
    //       await client
    //         .graphql({
    //           query: queries.listLinkUsersAndSites,
    //           authMode: "API_KEY",
    //           variables: {
    //             limit: 20000,
    //             nextToken: nextToken,
    //             filter: {
    //               status: {
    //                 eq: "Active",
    //               },
    //             },
    //           },
    //           authMode: "API_KEY",
    //         })
    //         .then((results) => {
    //           nextToken = results.data.listLinkUsersAndSites.nextToken;
    //           if (results.data.listLinkUsersAndSites.items.length > 0) {
    //             assets.push(results.data.listLinkUsersAndSites.items);
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //         });
    //     }
    //     console.log(assets);
    //     if (assets.length > 0) {
    //       const mergeAssets = assets.flat(1);

    //       console.log(mergeAssets);
    //       const linkedUsers = mergeAssets;
    //       const spDetailss = linkedUsers.filter((item) => {
    //         const _matchSites = siteDetailsGlobal?.find(
    //           (site) => site.id === item?.sitedetailsID
    //         );
    //         if (_matchSites) {
    //           return item;
    //         }
    //       });
    //       console.log(spDetailss);
    //       const filterSites = spDetailss.filter(
    //         (item) => item.sitedetailsID === selectedSiteGlobal
    //       );
    //       const filtersitesss = selectedSiteGlobal ? filterSites : spDetailss;
    //       console.log(siteDetailsGlobal);
    //       console.log(filtersitesss);
    //       //--
    //       let nextToken1 = "";
    //       let assets1 = [];
    //       await client
    //         .graphql({
    //           query: queries.listSPUserDetails,
    //           authMode: "API_KEY",
    //           variables: {
    //             filter: {
    //               userGroup: {
    //                 eq: "site_user",
    //               },
    //             },
    //             limit: 200000,
    //           },
    //         })
    //         .then(async (result) => {
    //           let assetDatas = result.data.listSPUserDetails.items;
    //           nextToken1 = result.data.listSPUserDetails.nextToken;
    //           if (result.data.listSPUserDetails.items.length > 0) {
    //             assets1.push(assetDatas);
    //           }
    //           while (nextToken1 !== null) {
    //             await client
    //               .graphql({
    //                 query: queries.listSPUserDetails,
    //                 authMode: "API_KEY",
    //                 variables: {
    //                   filter: {
    //                     userGroup: {
    //                       eq: "site_user",
    //                     },
    //                   },
    //                   limit: 200000,
    //                   nextToken: nextToken1,
    //                 },
    //                 authMode: "API_KEY",
    //               })
    //               .then((results) => {
    //                 nextToken1 = results.data.listSPUserDetails.nextToken;
    //                 if (results.data.listSPUserDetails.items.length > 0) {
    //                   assets1.push(results.data.listSPUserDetails.items);
    //                 }
    //               })
    //               .catch((error) => {
    //                 console.log(error);
    //                 setIsLoading(false);
    //               });
    //           }
    //           console.log(assets1);
    //           if (assets1.length > 0) {
    //             const mergeAssets1 = assets1.flat(1);
    //             console.log(mergeAssets1);
    //             const spDetails2 = mergeAssets1;
    //             const aoSP = spDetails2.filter((item) => {
    //               const _matchSites = filtersitesss?.find(
    //                 (linkUser) => linkUser.userdetailsID === item?.id
    //               );
    //               if (_matchSites) {
    //                 return item;
    //               }
    //             });
    //             console.log(aoSP);

    //             const filterSites = aoSP.filter(
    //               (item) => item.id === selectedSiteGlobal
    //             );
    //             const sortedItems = aoSP.sort((a, b) => {
    //               return new Date(b.createdAt) - new Date(a.createdAt);
    //             });
    //             const sortedItems2 = aoSP.sort((a, b) => {
    //               return new Date(b.createdAt) - new Date(a.createdAt);
    //             });
    //             console.log(sortedItems);
    //             //const spDetails = sortedItems2;
    //             //console.log(spDetails);
    //             const SpUsers = sortedItems2;
    //             if (onDateRangeSelected === "This Week") {
    //               siteUserDetails = SpUsers.filter(
    //                 (item) =>
    //                   moment(item.createdAt).format("DD/MM/YYYY") >=
    //                   moment(startOfWeek).format("DD/MM/YYYY") &&
    //                   moment(item.createdAt).format("DD/MM/YYYY") <=
    //                   moment(endOfWeek).format("DD/MM/YYYY")
    //               );
    //               //----Graph----------------------------------------
    //               let unique = siteUserDetails
    //                 .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //                 .filter(
    //                   (value, index, self) => self.indexOf(value) === index
    //                 );
    //               unique.map((uitem) => {
    //                 countsArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ).length
    //                 );
    //               });
    //               unique.map((uitem) => {
    //                 monthArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ) && uitem
    //                 );
    //               });
    //               setgraphLabelsSiteUsers(monthArray);
    //               setgraphDataSiteUsers(countsArray);
    //               //------------------graph-------------------end---------------
    //             } else if (onDateRangeSelected === "This Month") {
    //               siteUserDetails = SpUsers.filter(
    //                 (item) =>
    //                   moment(item.createdAt).format("DD/MM/YYYY") >=
    //                   moment(startOfMonth).format("DD/MM/YYYY") &&
    //                   moment(item.createdAt).format("DD/MM/YYYY") <=
    //                   moment(endOfMonth).format("DD/MM/YYYY")
    //               );
    //               //----Graph----------------------------------------
    //               let unique = siteUserDetails
    //                 .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //                 .filter(
    //                   (value, index, self) => self.indexOf(value) === index
    //                 );
    //               unique.map((uitem) => {
    //                 countsArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ).length
    //                 );
    //               });
    //               unique.map((uitem) => {
    //                 monthArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ) && uitem
    //                 );
    //               });
    //               setgraphLabelsSiteUsers(monthArray);
    //               setgraphDataSiteUsers(countsArray);
    //               //------------------graph-------------------end---------------
    //             } else if (onDateRangeSelected === "Today") {
    //               siteUserDetails = SpUsers.filter(
    //                 (item) =>
    //                   moment(item.createdAt).format("DD/MM/YYYY") ===
    //                   moment(new Date()).format("DD/MM/YYYY")
    //               );
    //               //----Graph----------------------------------------
    //               let unique = siteUserDetails
    //                 .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //                 .filter(
    //                   (value, index, self) => self.indexOf(value) === index
    //                 );
    //               unique.map((uitem) => {
    //                 countsArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ).length
    //                 );
    //               });
    //               unique.map((uitem) => {
    //                 monthArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ) && uitem
    //                 );
    //               });
    //               setgraphLabelsSiteUsers(monthArray);
    //               setgraphDataSiteUsers(countsArray);
    //               //------------------graph-------------------end---------------
    //             } else if (onDateRangeSelected === "This Year") {
    //               siteUserDetails = SpUsers.filter(
    //                 (item) =>
    //                   moment(item.createdAt).format("DD/MM/YYYY") >=
    //                   moment(startOfThisYear).format("YYYY-MM-DD") &&
    //                   moment(item.createdAt).format("DD/MM/YYYY") <=
    //                   moment(endOfThisYear).format("DD/MM/YYYY")
    //               );
    //               //----Graph----------------------------------------
    //               let unique = siteUserDetails
    //                 .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //                 .filter(
    //                   (value, index, self) => self.indexOf(value) === index
    //                 );
    //               unique.map((uitem) => {
    //                 countsArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ).length
    //                 );
    //               });
    //               unique.map((uitem) => {
    //                 monthArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ) && uitem
    //                 );
    //               });
    //               setgraphLabelsSiteUsers(monthArray);
    //               setgraphDataSiteUsers(countsArray);
    //               //------------------graph-------------------end---------------
    //             } else if (onDateRangeSelected === "Custom") {
    //               siteUserDetails = SpUsers.filter(
    //                 (item) =>
    //                   moment(item.createdAt).format("DD/MM/YYYY") >=
    //                   moment(startDate).format("DD/MM/YYYY") &&
    //                   moment(item.createdAt).format("DD/MM/YYYY") <=
    //                   moment(endDate).format("DD/MM/YYYY")
    //               );
    //               //----Graph----------------------------------------
    //               let unique = siteUserDetails
    //                 .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //                 .filter(
    //                   (value, index, self) => self.indexOf(value) === index
    //                 );
    //               unique.map((uitem) => {
    //                 countsArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ).length
    //                 );
    //               });
    //               unique.map((uitem) => {
    //                 monthArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ) && uitem
    //                 );
    //               });
    //               setgraphLabelsSiteUsers(monthArray);
    //               setgraphDataSiteUsers(countsArray);
    //               //------------------graph-------------------end---------------
    //             } else if (onDateRangeSelected === "All Time") {
    //               siteUserDetails = SpUsers;
    //               //----Graph----------------------------------------
    //               let unique = siteUserDetails
    //                 .map((item) => moment(item.createdAt).format("YYYY-MMM"))
    //                 .filter(
    //                   (value, index, self) => self.indexOf(value) === index
    //                 );
    //               unique.map((uitem) => {
    //                 countsArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ).length
    //                 );
    //               });
    //               unique.map((uitem) => {
    //                 monthArray.push(
    //                   siteUserDetails.filter(
    //                     (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
    //                   ) && uitem
    //                 );
    //               });
    //               setgraphLabelsSiteUsers(monthArray);
    //               setgraphDataSiteUsers(countsArray);
    //               //------------------graph-------------------end---------------
    //             }
    //             setListofSiteUsers(siteUserDetails);
    //             setIsLoading(false);
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //           setIsLoading(false);
    //         });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setIsLoading(false);
    //   });
    //----
    let nextToken1 = "";
    const result = await client.graphql({
      query: mergedQueries.listSUAOUserDetails,
      authMode: "API_KEY",
      variables: {
        limit: 10000,
        invitedBy: LoginUserDetails.id,
        userGroup: "site_user",
      },
    });
    if (result.data.listSPUserDetails.items.length > 0) {
      let assetDatas = result.data.listSPUserDetails.items;
      nextToken1 = result.data.listSPUserDetails.nextToken;
      if (result.data.listSPUserDetails.items.length > 0) {
        assets.push(assetDatas);
      }
      while (nextToken1 !== null) {
        const results = await client.graphql({
          query: mergedQueries.listSUAOUserDetails,
          authMode: "API_KEY",
          variables: {
            limit: 10000,
            invitedBy: LoginUserDetails.id,
            userGroup: "site_user",
            nextToken: nextToken1,
          },
        });
        if (results.data.listSPUserDetails.items.length > 0) {
          nextToken1 = results.data.listSPUserDetails.nextToken;
          if (results.data.listSPUserDetails.items.length > 0) {
            assets.push(results.data.listSPUserDetails.items);
          }
        }
      }
      console.log(assets);
      if (assets.length > 0) {
        const mergeAssets = assets.flat(1);

        console.log(mergeAssets);
        const linkedUsers = mergeAssets;
        const spDetailss = linkedUsers.filter((item) => {
          const _matchSites = siteDetailsGlobal?.find(
            (site) => site.id === item?.sitedetailsID
          );
          if (_matchSites) {
            return item;
          }
        });
        console.log(spDetailss);
        const filterSites = spDetailss.filter(
          (item) => item.sitedetailsID === selectedSiteGlobal
        );
        const filtersitesss = selectedSiteGlobal ? filterSites : spDetailss;
        console.log(siteDetailsGlobal);
        console.log(filtersitesss);
        //--
        let nextToken1 = "";
        let assets1 = [];
        await client
          .graphql({
            query: queries.listSPUserDetails,
            authMode: "API_KEY",
            variables: {
              filter: {
                userGroup: {
                  eq: "site_user",
                },
              },
              limit: 200000,
            },
          })
          .then(async (result) => {
            let assetDatas = result.data.listSPUserDetails.items;
            nextToken1 = result.data.listSPUserDetails.nextToken;
            if (result.data.listSPUserDetails.items.length > 0) {
              assets1.push(assetDatas);
            }
            while (nextToken1 !== null) {
              await client
                .graphql({
                  query: queries.listSPUserDetails,
                  authMode: "API_KEY",
                  variables: {
                    filter: {
                      userGroup: {
                        eq: "site_user",
                      },
                    },
                    limit: 200000,
                    nextToken: nextToken1,
                  },
                  authMode: "API_KEY",
                })
                .then((results) => {
                  nextToken1 = results.data.listSPUserDetails.nextToken;
                  if (results.data.listSPUserDetails.items.length > 0) {
                    assets1.push(results.data.listSPUserDetails.items);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setIsLoading(false);
                });
            }
            console.log(assets1);
            if (assets1.length > 0) {
              const mergeAssets1 = assets1.flat(1);
              console.log(mergeAssets1);
              const spDetails2 = mergeAssets1;
              const aoSP = spDetails2.filter((item) => {
                const _matchSites = filtersitesss?.find(
                  (linkUser) => linkUser.userdetailsID === item?.id
                );
                if (_matchSites) {
                  return item;
                }
              });
              console.log(aoSP);

              const filterSites = aoSP.filter(
                (item) => item.id === selectedSiteGlobal
              );
              const sortedItems = aoSP.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
              });
              const sortedItems2 = aoSP.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
              });
              console.log(sortedItems);
              //const spDetails = sortedItems2;
              //console.log(spDetails);
              const SpUsers = sortedItems2;
              if (onDateRangeSelected === "This Week") {
                siteUserDetails = SpUsers.filter(
                  (item) =>
                    moment(item.createdAt).format("DD/MM/YYYY") >=
                      moment(startOfWeek).format("DD/MM/YYYY") &&
                    moment(item.createdAt).format("DD/MM/YYYY") <=
                      moment(endOfWeek).format("DD/MM/YYYY")
                );
                //----Graph----------------------------------------
                let unique = siteUserDetails
                  .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                unique.map((uitem) => {
                  countsArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ).length
                  );
                });
                unique.map((uitem) => {
                  monthArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ) && uitem
                  );
                });
                setgraphLabelsSiteUsers(monthArray);
                setgraphDataSiteUsers(countsArray);
                //------------------graph-------------------end---------------
              } else if (onDateRangeSelected === "This Month") {
                siteUserDetails = SpUsers.filter(
                  (item) =>
                    moment(item.createdAt).format("DD/MM/YYYY") >=
                      moment(startOfMonth).format("DD/MM/YYYY") &&
                    moment(item.createdAt).format("DD/MM/YYYY") <=
                      moment(endOfMonth).format("DD/MM/YYYY")
                );
                //----Graph----------------------------------------
                let unique = siteUserDetails
                  .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                unique.map((uitem) => {
                  countsArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ).length
                  );
                });
                unique.map((uitem) => {
                  monthArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ) && uitem
                  );
                });
                setgraphLabelsSiteUsers(monthArray);
                setgraphDataSiteUsers(countsArray);
                //------------------graph-------------------end---------------
              } else if (onDateRangeSelected === "Today") {
                siteUserDetails = SpUsers.filter(
                  (item) =>
                    moment(item.createdAt).format("DD/MM/YYYY") ===
                    moment(new Date()).format("DD/MM/YYYY")
                );
                //----Graph----------------------------------------
                let unique = siteUserDetails
                  .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                unique.map((uitem) => {
                  countsArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ).length
                  );
                });
                unique.map((uitem) => {
                  monthArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ) && uitem
                  );
                });
                setgraphLabelsSiteUsers(monthArray);
                setgraphDataSiteUsers(countsArray);
                //------------------graph-------------------end---------------
              } else if (onDateRangeSelected === "This Year") {
                siteUserDetails = SpUsers.filter(
                  (item) =>
                    moment(item.createdAt).format("DD/MM/YYYY") >=
                      moment(startOfThisYear).format("YYYY-MM-DD") &&
                    moment(item.createdAt).format("DD/MM/YYYY") <=
                      moment(endOfThisYear).format("DD/MM/YYYY")
                );
                //----Graph----------------------------------------
                let unique = siteUserDetails
                  .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                unique.map((uitem) => {
                  countsArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ).length
                  );
                });
                unique.map((uitem) => {
                  monthArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ) && uitem
                  );
                });
                setgraphLabelsSiteUsers(monthArray);
                setgraphDataSiteUsers(countsArray);
                //------------------graph-------------------end---------------
              } else if (onDateRangeSelected === "Custom") {
                siteUserDetails = SpUsers.filter(
                  (item) =>
                    moment(item.createdAt).format("DD/MM/YYYY") >=
                      moment(startDate).format("DD/MM/YYYY") &&
                    moment(item.createdAt).format("DD/MM/YYYY") <=
                      moment(endDate).format("DD/MM/YYYY")
                );
                //----Graph----------------------------------------
                let unique = siteUserDetails
                  .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                unique.map((uitem) => {
                  countsArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ).length
                  );
                });
                unique.map((uitem) => {
                  monthArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ) && uitem
                  );
                });
                setgraphLabelsSiteUsers(monthArray);
                setgraphDataSiteUsers(countsArray);
                //------------------graph-------------------end---------------
              } else if (onDateRangeSelected === "All Time") {
                siteUserDetails = SpUsers;
                //----Graph----------------------------------------
                let unique = siteUserDetails
                  .map((item) => moment(item.createdAt).format("YYYY-MMM"))
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                unique.map((uitem) => {
                  countsArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ).length
                  );
                });
                unique.map((uitem) => {
                  monthArray.push(
                    siteUserDetails.filter(
                      (d) => moment(d.createdAt).format("YYYY-MMM") === uitem
                    ) && uitem
                  );
                });
                setgraphLabelsSiteUsers(monthArray);
                setgraphDataSiteUsers(countsArray);
                //------------------graph-------------------end---------------
              }
              setListofSiteUsers(siteUserDetails);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    } else {
      setListofSiteUsers([]);
      //setIsLoading(false);
    }
    return () => client.cancel();
  }
  //--- siteuser End --------
  const site = () => {
    navigate(`${process.env.PUBLIC_URL}/sites`);
  };
  const primary = "#5c61f2";

  const options = {
    chart: {
      height: 350,
      type: "line",
      id: "areachart-2",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    grid: {
      padding: {
        right: 30,
        left: 20,
      },
    },
    colors: [primary],
    yaxis: {
      title: {
        text: "Number of Assets",
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        rotate: -45,
        formatter: (val) => moment(val).format("MMM DD"),
      },
    },
  };

  const renderList = (
    <Fragment>
      <Container fluid={true} className="ecommerce-dash">
        <br></br>
        <Row>
          <Col md="9">
            <H5>Date Range Picker</H5>
            <span>
              {" "}
              <DateRangePicker
                onDateRangeSelected={onDateRangeSelected}
              ></DateRangePicker>{" "}
            </span>
          </Col>
          <Col md="3">
            <Btn attrBtn={{ color: "primary", onClick: site }}>
              Get Started With Site Set Up
            </Btn>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Row>
            <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.sitesCount
                              : siteDetails.length}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        <Link to={`/sites`}>Sites</Link>
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
                {/* <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {siteDetails.length > 0 && <Line data={chartSites} />}
                  </div>
                </CardBody> */}
              </Card>
            </Col>
            <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        <div>
                          <H5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.assetsCount
                              : assetsCount > 0
                              ? assetsCount
                              : 0}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        <Link to={`/catassetlist`}>Assets</Link>
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
                {/* <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {assetsCount > 0 && <Line data={chartAssets} />}
                  </div>
                </CardBody> */}
              </Card>
            </Col>
            {/* <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        <div className="media-end">
                          <H5>{assetOwnerDetailsList.length}</H5>
                        </div>
                      </div>
                      <H5>
                        <Link to={`/siteownerpanel/serviceprovider`}>
                          Pending Invitations
                        </Link>
                      </H5>
                    </Media>
                  </Media>
                </CardHeader>
                <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {assetOwnerDetailsList.length > 0 && (
                      <Line data={chartPendingInvitations} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col> */}
            <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.siteUsersCount
                              : listofSiteUsers.length}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        <Link to={`/siteownerpanel/siteUser`}>Site Users</Link>
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
                {/* <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {listofSiteUsers.length > 0 && (
                      <Line data={chartSiteUsers} />
                    )}
                  </div>
                </CardBody> */}
              </Card>
            </Col>
            {/* </Row>
          <Row> */}
            <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.serviceProvidersCount
                              : listofServiceProviders}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        <Link to={`/siteownerpanel/serviceprovider`}>
                          Service Providers
                        </Link>
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
                {/* <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {listofServiceProviders.length > 0 && (
                      <Line data={chartSP} />
                    )}
                  </div>
                </CardBody> */}
              </Card>
            </Col>
            <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.testsCount ?? 0
                              : testingDetailsList}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>Tests</H5>
                    </div>
                  </Media>
                </CardHeader>
                {/* <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {testingDetailsList.length > 0 && (
                      <Line data={chartTests} />
                    )}
                  </div>
                </CardBody> */}
              </Card>
            </Col>
            {/* </Row>
          <Row> */}
            <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <h5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.repairsCount ?? 0
                              : repairDetailsList}
                          </h5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>Repairs</H5>
                    </div>
                  </Media>
                </CardHeader>
                {/* <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {repairDetailsList.length > 0 && (
                      <Line data={chartRepairs} />
                    )}
                  </div>
                </CardBody> */}
              </Card>
            </Col>
            {/* <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        <div className="media-end">
                          <H5>
                            {selectedOption === "All Time"
                              ? fulldata[0]?.logbooksCount
                              : logBookDetailsList.length}
                          </H5>
                        </div>
                      </div>
                      <H5>
                        <Link to={`/generatereportfasset`}>Logbooks</Link>
                      </H5>
                    </Media>
                  </Media>
                </CardHeader>
                <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {logBookDetailsList.length > 0 && (
                      <Line data={chartLogBooks} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col> */}
            {/* <Col md="2" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        <div className="media-end">
                          <H5>{warantyDetailsList.length}</H5>
                        </div>
                      </div>
                      <H5>Warranty</H5>
                    </Media>
                  </Media>
                </CardHeader>
                <CardBody className="p-0">
                  <div className="crypto-dashborad-chart">
                    {warantyDetailsList.length > 0 && (
                      <Line data={chartWarranty} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col> */}
          </Row>
        </Row>
        <Row>
          <Col sm="12" xl="6" className="box-col-6">
            <Card>
              <CommenHeader title="Past 7 days Assets" />
              <CardBody>
                {loadingassets ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "350px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div id="basic-apex">
                    <Chart
                      options={options}
                      series={series}
                      height="350"
                      type="area"
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col sm="12" xl="6" className="box-col-6">
            <Card>
              <CommenHeader title="Tasks Count" />
              <CardBody>
                {loadingtasks ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "350px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div id="basic-apex">
                    <Chart
                      options={taskOptions}
                      series={taskSeries}
                      height="350"
                      type="area"
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <br></br>
      </Container>
    </Fragment>
  );
  return <div>{isLoading ? <LoadingSpinner /> : renderList}</div>;
};
export default AssetOwnerDashboard;
